webpackJsonp([3,5],{

/***/ "/356":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatModule; });
// /!\ DO ADD ANYTHING IN THERE WITHOUT TALKING TO FRONTEND INFRA FIRST /!\
var CompatModule = (function () {
    function CompatModule() {
    }
    return CompatModule;
}());

//# sourceMappingURL=compat.module.js.map

/***/ }),

/***/ "/fcW":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"app/@shared/tracking/tracking.module.ngfactory": [
		"5Wae",
		1
	],
	"compat/compat-navigation.module.ngfactory": [
		"44rj",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "/fcW";


/***/ }),

/***/ "/wVU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__environments_environment__ = __webpack_require__("kZql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__("Qbdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gendir_compat_compat_module_ngfactory__ = __webpack_require__("Bq6/");




if (__WEBPACK_IMPORTED_MODULE_1__environments_environment__["a" /* environment */].production) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["a" /* enableProdMode */])();
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["a" /* platformBrowser */])().bootstrapModuleFactory(__WEBPACK_IMPORTED_MODULE_3__gendir_compat_compat_module_ngfactory__["a" /* CompatModuleNgFactory */]);
//# sourceMappingURL=main-compat.js.map

/***/ }),

/***/ "0D9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatNavigationComponent; });
var CompatNavigationComponent = (function () {
    function CompatNavigationComponent() {
    }
    return CompatNavigationComponent;
}());

//# sourceMappingURL=compat-navigation.component.js.map

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("/wVU");


/***/ }),

/***/ "1LfM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component__ = __webpack_require__("wkYe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__ = __webpack_require__("sVtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__ = __webpack_require__("7eNd");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_NavigationPerformanceTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_NavigationPerformanceTrackingComponent_0;
/* unused harmony export NavigationPerformanceTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_NavigationPerformanceTrackingComponent = [];
var RenderType_NavigationPerformanceTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_NavigationPerformanceTrackingComponent,
    data: {}
});
function View_NavigationPerformanceTrackingComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [(l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_NavigationPerformanceTrackingComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 1, 'fl-navigation-performance-tracking', [], null, null, null, View_NavigationPerformanceTrackingComponent_0, RenderType_NavigationPerformanceTrackingComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_33" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component__["a" /* NavigationPerformanceTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__["a" /* Tracking */],
            __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]
        ], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var NavigationPerformanceTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_34" /* ɵccf */]('fl-navigation-performance-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_navigation_performance_tracking_component__["a" /* NavigationPerformanceTrackingComponent */], View_NavigationPerformanceTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9uYXZpZ2F0aW9uLXBlcmZvcm1hbmNlLXRyYWNraW5nLmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuTmF2aWdhdGlvblBlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuTmF2aWdhdGlvblBlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1uYXZpZ2F0aW9uLXBlcmZvcm1hbmNlLXRyYWNraW5nPjwvZmwtbmF2aWdhdGlvbi1wZXJmb3JtYW5jZS10cmFja2luZz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt5QkNBQTs7OztJQ0FBO2dCQUFBOzs7SUFBQTtLQUFBOzs7SUFBQTs7OyJ9
//# sourceMappingURL=navigation-performance-tracking.component.ngfactory.js.map

/***/ }),

/***/ "2qWf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("bKWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_user_reducer__ = __webpack_require__("6tnj");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationUserBalancesReducer; });


var navigationUserBalancesReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationUserBalances') {
                var ref = action.payload.ref;
                var data = action.payload.data;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__user_user_reducer__["b" /* transformUserBalances */])(data), ref);
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=userBalances.js.map

/***/ }),

/***/ "3iA8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("bKWi");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onlineOfflineReducer; });

var onlineOfflineReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'WS_MESSAGE':
            if (action.payload.type === 'onlineOffline') {
                var data = action.payload.data;
                return Object.entries(data).reduce(function (s, _a) {
                    var userId = _a[0], status = _a[1];
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["d" /* mergeEntity */])(s, { status: status }, [
                        'onlineOffline',
                        userId,
                    ]);
                }, state);
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=online-offline.reducer.js.map

/***/ }),

/***/ "4Vb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_auth__ = __webpack_require__("5/rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__("EEr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__ = __webpack_require__("TfWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("bKWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datastore_config__ = __webpack_require__("6NNA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datastore_interface__ = __webpack_require__("LaRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datastore_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__datastore_interface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__multiset__ = __webpack_require__("tTqL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sock_js__ = __webpack_require__("Qotf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__server_message_event_model__ = __webpack_require__("7Txn");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WebSocketService; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/* A library for working with SockJS websockets.
 * This is somewhat based on rxjs-websockets but with a lot of customisations
 * for freelancer.
 */











var WebSocketService = (function () {
    function WebSocketService(datastoreConfig, auth, store) {
        this.datastoreConfig = datastoreConfig;
        this.auth = auth;
        this.store = store;
        this.connectionStatus = new __WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__["BehaviorSubject"](0);
        this.fromServerStream = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.onlineOfflineSubs = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.open = false;
        this.channels = new Set();
        this.userSubscriptions = new __WEBPACK_IMPORTED_MODULE_8__multiset__["a" /* MultiSet */]();
        this.create();
        this.subscribeChannels([3]); // FIXME: Call this properly.
    }
    WebSocketService.prototype.create = function () {
        var _this = this;
        this.open = false;
        this.sock = new __WEBPACK_IMPORTED_MODULE_9__sock_js__["a" /* Socket */](this.datastoreConfig.webSocketUrl);
        this.auth.distinctUntilChanged().subscribe(function (auth) {
            _this.open = false;
            var closed = function () {
                if (!_this.open) {
                    return;
                }
                _this.connectionStatus.next(_this.connectionStatus.getValue() - 1);
                _this.onlineOfflineSubscription.unsubscribe();
                _this.open = false;
            };
            _this.sock.onopen = function () {
                _this.open = true;
                _this.connectionStatus.next(_this.connectionStatus.getValue() + 1);
                _this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["b" /* generateHeader */])(auth));
                _this.subscribeToUserEvents();
            };
            // Only send events with actual messages, not handshaking messages.
            _this.sock.onmessage = function (event) {
                var decodedEvent = JSON.parse(event.data);
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__server_message_event_model__["a" /* isSockMessageServerEvent */])(decodedEvent)) {
                    _this.processEvent(decodedEvent, auth.uid);
                }
            };
            _this.sock.onclose = function (event) {
                closed();
                if (event.wasClean) {
                    _this.fromServerStream.complete();
                }
                else {
                    _this.fromServerStream.error(new Error(event.reason));
                }
            };
            return function () {
                if (_this.sock) {
                    closed();
                    _this.sock.close();
                }
            };
        });
    };
    WebSocketService.prototype.sendEvent = function (message) {
        if (this.open) {
            this.sock.send(message);
        }
        else {
            console.error('Tried sending a message to a closed websocket.');
        }
    };
    WebSocketService.prototype.processEvent = function (event, userId) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__server_message_event_model__["b" /* isOnlineOfflineEvent */])(event)) {
            // The type of online/offline websockets is "statusget" :(
            this.store.dispatch({
                type: 'WS_MESSAGE',
                payload: {
                    data: event.body.data,
                    type: 'onlineOffline',
                    userId: String(userId),
                },
            });
        }
        else {
            this.store.dispatch({
                type: 'WS_MESSAGE',
                payload: __assign({}, event.body, { userId: String(userId) }),
            });
        }
        // Once the store is updated then we can let everyone know.
        this.fromServerStream.next(event);
    };
    /* We buffer the user subscriptions and unsubscriptions by 1 second
      * to reduce backend load.
      * It's possible to have subscribed and unsubscriped within that buffer
      * so we remove such sub/unsub (and reverse) manually.
    */
    WebSocketService.prototype.subscribeToUserEvents = function () {
        var _this = this;
        // Subscribe to existing subscriptions
        var existingSubscriptions = this.userSubscriptions.values();
        if (existingSubscriptions.length) {
            this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["c" /* generateUserSub */])(existingSubscriptions));
        }
        if (this.channels.size) {
            this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["d" /* generateChannelSubMessage */])(Array.from(this.channels)));
        }
        // Subscribe to any new ones that come in
        this.onlineOfflineSubscription = this.onlineOfflineSubs
            .bufferTime(1000)
            .subscribe(function (userIds) {
            var reducedSubscriptions = userIds.reduce(function (acc, current) {
                var subs = acc.subs;
                var unsubs = acc.unsubs;
                if (current.type === 'sub') {
                    if (acc.unsubs.includes(current.id)) {
                        unsubs = acc.unsubs.filter(function (id) { return id !== current.id; });
                    }
                    else {
                        subs = acc.subs.concat([current.id]);
                    }
                }
                if (current.type === 'unsub') {
                    if (acc.subs.includes(current.id)) {
                        subs = acc.subs.filter(function (id) { return id !== current.id; });
                    }
                    else {
                        unsubs = acc.unsubs.concat([current.id]);
                    }
                }
                return { subs: subs, unsubs: unsubs };
            }, { subs: [], unsubs: [] });
            if (reducedSubscriptions.subs.length) {
                _this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["c" /* generateUserSub */])(reducedSubscriptions.subs));
            }
            if (reducedSubscriptions.unsubs.length) {
                _this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["e" /* generateUserUnsub */])(reducedSubscriptions.unsubs));
            }
            return;
        });
    };
    WebSocketService.prototype.subscribeOnlineOffline = function (userId) {
        var _this = this;
        // Watch the user id stream, calculate watch for changes,
        // subscribe/unsubscribe to any additions/removals respectively
        // and return the user status for the user who is subscribed to.
        // We add `undefined` to the end so we can get the last unsub.
        return userId
            .distinctUntilChanged()
            .concat(__WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__["Observable"].of(undefined))
            .scan(function (acc, next) { return ({
            current: next,
            previous: acc.current,
        }); }, {
            current: undefined,
            previous: undefined,
        })
            .map(function (_a) {
            var previous = _a.previous, current = _a.current;
            if (previous) {
                _this.unsubscribeUserOnlineOffline(previous);
            }
            if (current) {
                _this.subscribeUserOnlineOffline(current);
            }
            return current;
        });
    };
    WebSocketService.prototype.subscribeUserOnlineOffline = function (userId) {
        // If this user id is new, subscribe.
        if (this.userSubscriptions.multiplicity(userId) === 0) {
            this.onlineOfflineSubs.next({ type: 'sub', id: userId });
        }
        this.userSubscriptions.add(userId);
    };
    WebSocketService.prototype.unsubscribeUserOnlineOffline = function (userId) {
        // If this user id is the last one, unsubscribe.
        if (this.userSubscriptions.multiplicity(userId) === 1) {
            this.onlineOfflineSubs.next({ type: 'unsub', id: userId });
        }
        this.userSubscriptions.remove(userId);
    };
    WebSocketService.prototype.subscribeChannels = function (channels) {
        var _this = this;
        this.sendEvent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__sock_js__["d" /* generateChannelSubMessage */])(channels));
        channels.forEach(function (channel) { return _this.channels.add(channel); });
    };
    WebSocketService.prototype.unsubscribeChannels = function (channels) {
        console.log('Not implemented');
    };
    WebSocketService.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_7__datastore_interface__["DatastoreConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_6__datastore_config__["a" /* DATASTORE_CONFIG */]] }] }, { type: __WEBPACK_IMPORTED_MODULE_1__shared_auth__["a" /* Auth */] }, { type: __WEBPACK_IMPORTED_MODULE_5__store__["b" /* Store */] }]; };
    return WebSocketService;
}());

//# sourceMappingURL=websocket.js.map

/***/ }),

/***/ "5/rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_config__ = __webpack_require__("Tz6n");
/* unused harmony reexport AUTH_CONFIG */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_interface__ = __webpack_require__("LV28");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__auth_interface__);
/* unused harmony reexport AuthConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_module__ = __webpack_require__("OTuB");
/* unused harmony reexport AuthModule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_service__ = __webpack_require__("TZHD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__auth_service__["a"]; });
/* unused harmony reexport AuthState */




//# sourceMappingURL=index.js.map

/***/ }),

/***/ "5MCJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("bKWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transformers__ = __webpack_require__("7Aw9");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return navigationProjectFeedReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationProjectFeedFailingProjectsReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return navigationProjectFeedFailingContestsReducer; });


var navigationProjectFeedReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationProjectFeed') {
                var ref = action.payload.ref;
                var data = action.payload.data;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transformers__["c" /* transformNavigationProjectFeedItems */])(data), ref);
            }
            return state;
        case 'WS_MESSAGE':
            if (action.payload.type === 'project') {
                var _a = action.payload, data = _a.data, userId = _a.userId;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transformers__["d" /* transformNavigationProjectFeedWS */])(data), { path: ['navigationProjectFeed', userId] }, 'time');
            }
            return state;
        default:
            return state;
    }
};
var navigationProjectFeedFailingProjectsReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationProjectFeedFailingProjects') {
                var ref = action.payload.ref;
                var data = action.payload.data;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transformers__["c" /* transformNavigationProjectFeedItems */])(data), ref);
            }
            return state;
        default:
            return state;
    }
};
var navigationProjectFeedFailingContestsReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationProjectFeedFailingContests') {
                var ref = action.payload.ref;
                var data = action.payload.data;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transformers__["c" /* transformNavigationProjectFeedItems */])(data), ref);
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=projectFeed.js.map

/***/ }),

/***/ "5SOI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datastore__ = __webpack_require__("wIBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datastore_config__ = __webpack_require__("6NNA");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatastoreModule; });


var DatastoreModule = (function () {
    function DatastoreModule() {
    }
    DatastoreModule.initialize = function (config) {
        return {
            ngModule: DatastoreModule,
            providers: [__WEBPACK_IMPORTED_MODULE_0__datastore__["a" /* Datastore */], { provide: __WEBPACK_IMPORTED_MODULE_1__datastore_config__["a" /* DATASTORE_CONFIG */], useValue: config }],
        };
    };
    return DatastoreModule;
}());

//# sourceMappingURL=datastore.module.js.map

/***/ }),

/***/ "6NNA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATASTORE_CONFIG; });

var DATASTORE_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["_20" /* OpaqueToken */]('DatastoreConfig');
//# sourceMappingURL=datastore.config.js.map

/***/ }),

/***/ "6mmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backend__ = __webpack_require__("OoH7");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListObservable; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var ListObservable = (function (_super) {
    __extends(ListObservable, _super);
    function ListObservable(ref$, apiHttp, store, source) {
        var _this = _super.call(this) || this;
        _this.ref$ = ref$;
        _this.apiHttp = apiHttp;
        _this.store = store;
        _this.source = source;
        return _this;
    }
    ListObservable.prototype.lift = function (operator) {
        var observable = new ListObservable(this.ref$, this.apiHttp, this.store, this);
        observable.operator = operator;
        return observable;
    };
    ListObservable.prototype.push = function (body) {
        var _this = this;
        return this.ref$
            .take(1)
            .switchMap(function (ref) {
            var path = ref.path, query = ref.query;
            var post = __WEBPACK_IMPORTED_MODULE_1__backend__["a" /* backend */][path[0]].post;
            if (post) {
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(post(path[1]))
                    .do(function (data) {
                    return _this.store.dispatch({
                        type: 'API_POST',
                        payload: { data: data, ref: ref },
                    });
                })
                    .switchMap(function (config) { return _this.apiHttp.post(config, body); })
                    .do(function (data) {
                    return _this.store.dispatch({
                        type: 'API_POST_SUCCESS',
                        payload: { data: data, ref: ref },
                    });
                });
            }
        })
            .mapTo(true);
    };
    return ListObservable;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"]));

//# sourceMappingURL=list-observable.js.map

/***/ }),

/***/ "6tnj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformUser;
/* unused harmony export transformUserImage */
/* harmony export (immutable) */ __webpack_exports__["b"] = transformUserBalances;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function transformUser(user) {
    return {
        id: user.id,
        avatar: transformUserImage(user.avatar),
        avatarLarge: transformUserImage(user.avatar_large),
        username: user.username,
        displayName: user.display_name,
        role: user.role,
        profileUrl: "/u/" + user.username + ".html",
    };
}
function transformUserImage(image) {
    return image !== '/img/unknown.png' ? image : undefined;
}
function transformUserBalances(user) {
    return user.account_balances.balances.reduce(function (acc, balance) {
        return (__assign({}, acc, (_a = {}, _a[balance.currency.id] = __assign({}, balance, { primary: balance.currency.code === user.primary_currency.code }), _a)));
        var _a;
    }, {});
}
//# sourceMappingURL=user.reducer.js.map

/***/ }),

/***/ "7Aw9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = transformNavigationNotifications;
/* harmony export (immutable) */ __webpack_exports__["b"] = transformNavigationUserInfo;
/* unused harmony export transformNavigationProjectFeedItem */
/* harmony export (immutable) */ __webpack_exports__["c"] = transformNavigationProjectFeedItems;
/* harmony export (immutable) */ __webpack_exports__["d"] = transformNavigationProjectFeedWS;
/* harmony export (immutable) */ __webpack_exports__["a"] = transformUserRecentProjectsAndContests;
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function transformNavigationNotifications(entries) {
    return entries.reduce(function (acc, entry) {
        var id = entry.type === 'contestAwardedToEmployer'
            ? entry.data.entry_id
            : entry.type === 'draftContest' ? entry.data.contestId : entry.data.id;
        return __assign({}, acc, (_a = {}, _a[entry.type + "-" + id] = { type: entry.type, data: entry.data }, _a));
        var _a;
    }, {});
}
// This takes an API response and transforms it into a User object
function transformNavigationUserInfo(navigation) {
    return {
        id: navigation.id,
        username: navigation.username,
        publicName: navigation.publicName,
        isFreeTrialEligible: navigation.isFreeTrialEligible,
        isPlusTrialEligible: navigation.isPlusTrialEligible,
        trialPackageId: navigation.trialPackageId,
        isPremium: navigation.isPremium,
        logo: navigation.logo,
        membership: navigation.membership,
        hideMembershipUpgradeButton: navigation.hideMembershipUpgradeButton,
        trialDuration: navigation.trialDuration,
        trialLandingUrl: navigation.trialLandingUrl,
        monthlyTrial: navigation.monthlyTrial,
        canSwitchToUsers: navigation.canSwitchToUsers,
        isNoCommissionEligibleReferrer: navigation.isNoCommissionEligibleReferrer,
    };
}
// This takes an API response and transforms it into a NavigationProjectFeed object
function transformNavigationProjectFeedItem(item) {
    return _a = {},
        _a[item.type + "-" + item.id] = {
            id: item.id,
            appendedDescr: item.appended_descr,
            currency: item.currency,
            currencyCode: item.currencyCode,
            exchangerate: item.exchangerate,
            featured: item.featured,
            freeBidUntil: item.free_bid_until,
            fulltime: item.fulltime,
            // hidebids: item.hidebids,
            imgUrl: item.imgUrl,
            isMinimallyPostedProject: item.isMinimallyPostedProject,
            jobs: item.jobs.map(function (job) { return Number(job); }),
            jobString: item.jobString,
            linkUrl: item.linkUrl,
            maxbudget: Number(item.maxbudget),
            minbudget: Number(item.minbudget),
            minimallyPostedProjectBudgetSet: item.minimallyPostedProjectBudgetSet,
            nonpublic: item.nonpublic,
            projIsHourly: item.projIsHourly,
            showBudgetMinimallyPostedProject: item.showBudgetMinimallyPostedProject,
            submitDate: item.submitDate,
            text: item.text,
            time: item.time * 1000,
            title: item.title,
            type: item.type,
            userId: Number(item.userId),
            userName: item.userName,
        },
        _a;
    var _a;
}
// This takes an API response and transforms it into a NavigationProjectFeed object
function transformNavigationProjectFeedItems(items) {
    if (items) {
        return items.reduce(function (acc, item) { return (__assign({}, acc, transformNavigationProjectFeedItem(item))); }, {});
    }
    return {};
}
function transformNavigationProjectFeedWS(item) {
    return _a = {},
        _a["project-" + item.id] = {
            id: item.id,
            appendedDescr: item.appended_descr,
            currency: item.currency,
            currencyCode: item.currencyCode,
            exchangerate: item.exchangerate,
            featured: item.featured,
            freeBidUntil: item.free_bid_until,
            fulltime: item.fulltime,
            imgUrl: item.imgUrl,
            isMinimallyPostedProject: item.isMinimallyPostedProject,
            jobs: item.jobs.map(function (job) { return Number(job); }),
            jobString: item.jobString,
            linkUrl: item.linkUrl,
            maxbudget: Number(item.maxbudget),
            minbudget: Number(item.minbudget),
            minimallyPostedProjectBudgetSet: item.minimallyPostedProjectBudgetSet,
            nonpublic: item.nonpublic,
            projIsHourly: item.projIsHourly,
            showBudgetMinimallyPostedProject: item.showBudgetMinimallyPostedProject,
            submitDate: item.submitDate,
            text: item.text,
            time: item.time * 1000,
            title: item.title,
            type: 'project',
            userId: Number(item.userId),
            userName: item.userName,
        },
        _a;
    var _a;
}
function transformUserRecentProjectsAndContests(item) {
    return item.list.map(function (listItem) { return (__assign({}, listItem, { urlPart: listItem.type === 'project'
            ? "/projects/" + listItem.urlPart
            : listItem.urlPart })); });
}
//# sourceMappingURL=transformers.js.map

/***/ }),

/***/ "7Txn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isOnlineOfflineEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = isSockMessageServerEvent;
function isOnlineOfflineEvent(event) {
    return (event.channel === 'user' &&
        event.body &&
        event.body.parent_type === 'onlineoffline');
}
function isSockMessageServerEvent(event) {
    return event.channel === 'user';
}
//# sourceMappingURL=server-message-event.model.js.map

/***/ }),

/***/ "7eNd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_CONFIG; });

var TRACKING_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["_20" /* OpaqueToken */]('TrackingConfig');
//# sourceMappingURL=tracking.config.js.map

/***/ }),

/***/ "8OhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compat_compat_component__ = __webpack_require__("t/ph");
/* unused harmony export RenderType_CompatComponent */
/* unused harmony export View_CompatComponent_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */


var styles_CompatComponent = [];
var RenderType_CompatComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_CompatComponent,
    data: {}
});
function View_CompatComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_40" /* ɵqud */](402653184, 1, { entryPoint: 0 }),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_31" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](16777216, [
            [
                1,
                3
            ],
            [
                'entryPoint',
                1
            ]
        ], null, 0, null, null, null, null, null, null, null)),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_31" /* ɵted */](null, ['\n  ']))
    ], null, null);
}
function View_CompatComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 1, 'webapp-compat', [], null, null, null, View_CompatComponent_0, RenderType_CompatComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_33" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__compat_compat_component__["a" /* CompatComponent */], [
            [
                1,
                __WEBPACK_IMPORTED_MODULE_0__angular_core__["X" /* Injector */]
            ],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["z" /* NgModuleFactoryLoader */]
        ], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var CompatComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_34" /* ɵccf */]('webapp-compat', __WEBPACK_IMPORTED_MODULE_1__compat_compat_component__["a" /* CompatComponent */], View_CompatComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0LmNvbXBvbmVudC50cyIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5jb21wb25lbnQudHMuQ29tcGF0Q29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2NvbXBhdC9jb21wYXQuY29tcG9uZW50LnRzLkNvbXBhdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxuZy1jb250YWluZXIgI2VudHJ5UG9pbnQ+PC9uZy1jb250YWluZXI+XG4gICIsIjx3ZWJhcHAtY29tcGF0Pjwvd2ViYXBwLWNvbXBhdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FBO0lBQ0k7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBQXlDOzs7Ozs7SUNEN0M7Z0JBQUE7TUFBQTtRQUFBOztNQUFBOzs7SUFBQTtLQUFBOzs7SUFBQTs7OyJ9
//# sourceMappingURL=compat.component.ngfactory.js.map

/***/ }),

/***/ "8kLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__websocket__ = __webpack_require__("4Vb3");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__websocket__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__server_message_event_model__ = __webpack_require__("7Txn");
/* unused harmony reexport WebsocketBaseEvent */
/* unused harmony reexport WebsocketAwardEvent */
/* unused harmony reexport WebsocketAwardBadgeEvent */
/* unused harmony reexport WebsocketAwardCreditEvent */
/* unused harmony reexport WebsocketAwardMilestoneReminderEvent */
/* unused harmony reexport WebsocketAwardReminderEvent */
/* unused harmony reexport WebsocketAwardXpEvent */
/* unused harmony reexport WebsocketBidEvent */
/* unused harmony reexport WebsocketCompletedEvent */
/* unused harmony reexport WebsocketContactRequestReceivedEvent */
/* unused harmony reexport WebsocketContestEvent */
/* unused harmony reexport WebsocketContestAwardedToEmployerEvent */
/* unused harmony reexport WebsocketContestAwardedToFreelancerEvent */
/* unused harmony reexport WebsocketContestEntryEvent */
/* unused harmony reexport WebsocketContestEntryBoughtToEmployerEvent */
/* unused harmony reexport WebsocketContestEntryBoughtToFreelancerEvent */
/* unused harmony reexport WebsocketContestPCBNotificationEvent */
/* unused harmony reexport WebsocketContestPCBNotificationFullViewEvent */
/* unused harmony reexport WebsocketCreateMilestoneEvent */
/* unused harmony reexport WebsocketDenyedEvent */
/* unused harmony reexport WebsocketDraftContestEvent */
/* unused harmony reexport WebsocketFailingProjectEvent */
/* unused harmony reexport WebsocketHighLtvAnnualDiscountEvent */
/* unused harmony reexport WebsocketInviteToContestEvent */
/* unused harmony reexport WebsocketInviteUserBidEvent */
/* unused harmony reexport WebsocketInvoiceRequestedEvent */
/* unused harmony reexport WebsocketLevelupEvent */
/* unused harmony reexport WebsocketNotifyfollowerEvent */
/* unused harmony reexport WebsocketProjectEvent */
/* unused harmony reexport WebsocketProjectRecruiterEvent */
/* unused harmony reexport WebsocketQuickHireProjectEvent */
/* unused harmony reexport WebsocketReleaseMilestoneEvent */
/* unused harmony reexport WebsocketRequestEndProjectEvent */
/* unused harmony reexport WebsocketRequestMilestoneEvent */
/* unused harmony reexport WebsocketRequestToReleaseEvent */
/* unused harmony reexport WebsocketServiceApprovedEvent */
/* unused harmony reexport WebsocketServiceProjectEndingSellerEvent */
/* unused harmony reexport WebsocketServiceProjectPostedSellerEvent */
/* unused harmony reexport WebsocketServiceRejectedEvent */
/* unused harmony reexport WebsocketSignUpFreeTrialUpsellEvent */
/* unused harmony reexport WebsocketSitesBinCreatedEvent */
/* unused harmony reexport WebsocketSitesHandOverMessageSentEvent */
/* unused harmony reexport WebsocketSitesListingStatusChangedEvent */
/* unused harmony reexport WebsocketSitesMessageSentEvent */
/* unused harmony reexport WebsocketSitesOfferCreatedEvent */
/* unused harmony reexport WebsocketUpsellCrowdsourceFindingEvent */
/* unused harmony reexport WebsocketXpContestEvent */


//# sourceMappingURL=index.js.map

/***/ }),

/***/ "9gmB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_performance_tracking_component_ngfactory__ = __webpack_require__("1LfM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_navigation_performance_tracking_component__ = __webpack_require__("wkYe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_service__ = __webpack_require__("sVtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_tracking_tracking_config__ = __webpack_require__("7eNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_timing_tracking_component_ngfactory__ = __webpack_require__("jT3v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_user_timing_tracking_component__ = __webpack_require__("EVHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__memory_leak_tracking_component_ngfactory__ = __webpack_require__("xfqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_shared_tracking_memory_leak_tracking_component__ = __webpack_require__("cjBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_shared_tracking_error_tracking_service__ = __webpack_require__("maH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__synthetic_performance_tracking_component_ngfactory__ = __webpack_require__("SPEl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_synthetic_performance_tracking_component__ = __webpack_require__("yUzi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ngx_cookie_src_cookie_service__ = __webpack_require__("A+9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app_shared_tracking_tracking_component__ = __webpack_require__("PzJT");
/* unused harmony export RenderType_TrackingComponent */
/* unused harmony export View_TrackingComponent_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackingComponentNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */














var styles_TrackingComponent = [];
var RenderType_TrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_TrackingComponent,
    data: {}
});
function View_TrackingComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_31" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 1, 'fl-navigation-performance-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_1__navigation_performance_tracking_component_ngfactory__["a" /* View_NavigationPerformanceTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_1__navigation_performance_tracking_component_ngfactory__["b" /* RenderType_NavigationPerformanceTrackingComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_33" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_navigation_performance_tracking_component__["a" /* NavigationPerformanceTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_service__["a" /* Tracking */],
            __WEBPACK_IMPORTED_MODULE_4__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]
        ], null, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_31" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 1, 'fl-user-timing-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_5__user_timing_tracking_component_ngfactory__["a" /* View_UserTimingTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_5__user_timing_tracking_component_ngfactory__["b" /* RenderType_UserTimingTrackingComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_33" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_user_timing_tracking_component__["a" /* UserTimingTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_service__["a" /* Tracking */]], null, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_31" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 1, 'fl-memory-leak-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_7__memory_leak_tracking_component_ngfactory__["a" /* View_MemoryLeakTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_7__memory_leak_tracking_component_ngfactory__["b" /* RenderType_MemoryLeakTrackingComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_33" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_8__app_shared_tracking_memory_leak_tracking_component__["a" /* MemoryLeakTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_9__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */],
            __WEBPACK_IMPORTED_MODULE_4__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]
        ], null, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_31" /* ɵted */](null, ['\n    '])),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 1, 'fl-synthetic-performance-tracking', [], null, null, null, __WEBPACK_IMPORTED_MODULE_10__synthetic_performance_tracking_component_ngfactory__["a" /* View_SyntheticPerformanceTrackingComponent_0 */], __WEBPACK_IMPORTED_MODULE_10__synthetic_performance_tracking_component_ngfactory__["b" /* RenderType_SyntheticPerformanceTrackingComponent */])),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_33" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_11__app_shared_tracking_synthetic_performance_tracking_component__["a" /* SyntheticPerformanceTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_12_ngx_cookie_src_cookie_service__["a" /* CookieService */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["_21" /* Renderer2 */]
        ], null, null),
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_31" /* ɵted */](null, ['\n  ']))
    ], function (ck, v) {
        ck(v, 2, 0);
        ck(v, 5, 0);
        ck(v, 8, 0);
        ck(v, 11, 0);
    }, null);
}
function View_TrackingComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 1, 'fl-tracking', [], null, null, null, View_TrackingComponent_0, RenderType_TrackingComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_33" /* ɵdid */](49152, null, 0, __WEBPACK_IMPORTED_MODULE_13__app_shared_tracking_tracking_component__["a" /* TrackingComponent */], [], null, null)
    ], null, null);
}
var TrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_34" /* ɵccf */]('fl-tracking', __WEBPACK_IMPORTED_MODULE_13__app_shared_tracking_tracking_component__["a" /* TrackingComponent */], View_TrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy90cmFja2luZy5jb21wb25lbnQudHMuVHJhY2tpbmdDb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcuY29tcG9uZW50LnRzLlRyYWNraW5nQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGZsLW5hdmlnYXRpb24tcGVyZm9ybWFuY2UtdHJhY2tpbmc+PC9mbC1uYXZpZ2F0aW9uLXBlcmZvcm1hbmNlLXRyYWNraW5nPlxuICAgIDxmbC11c2VyLXRpbWluZy10cmFja2luZz48L2ZsLXVzZXItdGltaW5nLXRyYWNraW5nPlxuICAgIDxmbC1tZW1vcnktbGVhay10cmFja2luZz48L2ZsLW1lbW9yeS1sZWFrLXRyYWNraW5nPlxuICAgIDxmbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+PC9mbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+XG4gICIsIjxmbC10cmFja2luZz48L2ZsLXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtJQUNJO2dCQUFBOzs7SUFBQTtLQUFBO0lBQXlFO0lBQ3pFO2dCQUFBO0lBQW1EO0lBQ25EO2dCQUFBOzs7SUFBQTtLQUFBO0lBQW1EO0lBQ25EO2dCQUFBOzs7SUFBQTtLQUFBO0lBQXVFOzs7SUFIdkU7SUFDQTtJQUNBO0lBQ0E7Ozs7O0lDSko7Z0JBQUE7Ozs7In0=
//# sourceMappingURL=tracking.component.ngfactory.js.map

/***/ }),

/***/ "Bq6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compat_compat_module__ = __webpack_require__("/356");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ngx_cookie_src_cookie_options_provider__ = __webpack_require__("8xgx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_shared_auth_auth_service__ = __webpack_require__("TZHD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_shared_tracking_error_tracking_service__ = __webpack_require__("maH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_custom_error_handler_service__ = __webpack_require__("UbRn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__ = __webpack_require__("Qbdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__ = __webpack_require__("KN8t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ngx_cookie_index__ = __webpack_require__("9db2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_shared_auth_auth_module__ = __webpack_require__("OTuB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ngrx_store_src_ng2__ = __webpack_require__("cPow");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__ = __webpack_require__("uf2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_shared_datastore_datastore_module__ = __webpack_require__("5SOI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__app_shared_tracking_tracking_module__ = __webpack_require__("k/7A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ngrx_store_devtools_src_extension__ = __webpack_require__("MjDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ngrx_store_devtools_src_devtools__ = __webpack_require__("cnKp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ngrx_store_src_dispatcher__ = __webpack_require__("osFu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__app_shared_datastore_api_http_service__ = __webpack_require__("gW6X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__app_shared_datastore_websocket_websocket__ = __webpack_require__("4Vb3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__app_shared_datastore_datastore__ = __webpack_require__("wIBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__app_shared_tracking_tracking_service__ = __webpack_require__("sVtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__app_shared_tracking_tracking_component_ngfactory__ = __webpack_require__("9gmB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__compat_component_ngfactory__ = __webpack_require__("8OhN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_ngx_cookie_src_cookie_factory__ = __webpack_require__("Ji/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__app_shared_datastore_store__ = __webpack_require__("bKWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__app_shared_tracking_tracking_component__ = __webpack_require__("PzJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__compat_compat_navigation_component__ = __webpack_require__("0D9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__app_shared_auth_auth_config__ = __webpack_require__("Tz6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_ngx_cookie_src_cookie_service__ = __webpack_require__("A+9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__app_shared_tracking_tracking_config__ = __webpack_require__("7eNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__angular_animations_browser__ = __webpack_require__("1GJ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ngrx_store_src_reducer__ = __webpack_require__("oi6x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ngrx_store_devtools_src_config__ = __webpack_require__("2iB7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ngrx_store_src_state__ = __webpack_require__("NPiC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ngrx_store_src_store__ = __webpack_require__("Zcpd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__app_shared_datastore_datastore_config__ = __webpack_require__("6NNA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__angular_router__ = __webpack_require__("5oXY");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatModuleNgFactory; });
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







































var CompatModuleInjector = (function (_super) {
    __extends(CompatModuleInjector, _super);
    function CompatModuleInjector(parent) {
        return _super.call(this, parent, [
            __WEBPACK_IMPORTED_MODULE_23__app_shared_tracking_tracking_component_ngfactory__["a" /* TrackingComponentNgFactory */],
            __WEBPACK_IMPORTED_MODULE_24__compat_component_ngfactory__["a" /* CompatComponentNgFactory */]
        ], [__WEBPACK_IMPORTED_MODULE_24__compat_component_ngfactory__["a" /* CompatComponentNgFactory */]]) || this;
    }
    Object.defineProperty(CompatModuleInjector.prototype, "_LOCALE_ID_24", {
        get: function () {
            if ((this.__LOCALE_ID_24 == null)) {
                (this.__LOCALE_ID_24 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["b" /* ɵn */](this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["c" /* LOCALE_ID */], null)));
            }
            return this.__LOCALE_ID_24;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_NgLocalization_25", {
        get: function () {
            if ((this.__NgLocalization_25 == null)) {
                (this.__NgLocalization_25 = new __WEBPACK_IMPORTED_MODULE_2__angular_common__["a" /* NgLocaleLocalization */](this._LOCALE_ID_24));
            }
            return this.__NgLocalization_25;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Compiler_26", {
        get: function () {
            if ((this.__Compiler_26 == null)) {
                (this.__Compiler_26 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* Compiler */]());
            }
            return this.__Compiler_26;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_APP_ID_27", {
        get: function () {
            if ((this.__APP_ID_27 == null)) {
                (this.__APP_ID_27 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["e" /* ɵg */]());
            }
            return this.__APP_ID_27;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_IterableDiffers_28", {
        get: function () {
            if ((this.__IterableDiffers_28 == null)) {
                (this.__IterableDiffers_28 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["f" /* ɵl */]());
            }
            return this.__IterableDiffers_28;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_KeyValueDiffers_29", {
        get: function () {
            if ((this.__KeyValueDiffers_29 == null)) {
                (this.__KeyValueDiffers_29 = __WEBPACK_IMPORTED_MODULE_0__angular_core__["g" /* ɵm */]());
            }
            return this.__KeyValueDiffers_29;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_DomSanitizer_30", {
        get: function () {
            if ((this.__DomSanitizer_30 == null)) {
                (this.__DomSanitizer_30 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["b" /* ɵe */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__DomSanitizer_30;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Sanitizer_31", {
        get: function () {
            if ((this.__Sanitizer_31 == null)) {
                (this.__Sanitizer_31 = this._DomSanitizer_30);
            }
            return this.__Sanitizer_31;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_HAMMER_GESTURE_CONFIG_32", {
        get: function () {
            if ((this.__HAMMER_GESTURE_CONFIG_32 == null)) {
                (this.__HAMMER_GESTURE_CONFIG_32 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["d" /* HammerGestureConfig */]());
            }
            return this.__HAMMER_GESTURE_CONFIG_32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_EVENT_MANAGER_PLUGINS_33", {
        get: function () {
            if ((this.__EVENT_MANAGER_PLUGINS_33 == null)) {
                (this.__EVENT_MANAGER_PLUGINS_33 = [
                    new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["e" /* ɵDomEventsPlugin */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])),
                    new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["f" /* ɵKeyEventsPlugin */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])),
                    new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["g" /* ɵHammerGesturesPlugin */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */]), this._HAMMER_GESTURE_CONFIG_32)
                ]);
            }
            return this.__EVENT_MANAGER_PLUGINS_33;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_EventManager_34", {
        get: function () {
            if ((this.__EventManager_34 == null)) {
                (this.__EventManager_34 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["h" /* EventManager */](this._EVENT_MANAGER_PLUGINS_33, this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* NgZone */])));
            }
            return this.__EventManager_34;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_\u0275DomSharedStylesHost_35", {
        get: function () {
            if ((this.__ɵDomSharedStylesHost_35 == null)) {
                (this.__ɵDomSharedStylesHost_35 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["i" /* ɵDomSharedStylesHost */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__ɵDomSharedStylesHost_35;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_\u0275DomRendererFactory2_36", {
        get: function () {
            if ((this.__ɵDomRendererFactory2_36 == null)) {
                (this.__ɵDomRendererFactory2_36 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["j" /* ɵDomRendererFactory2 */](this._EventManager_34, this._ɵDomSharedStylesHost_35));
            }
            return this.__ɵDomRendererFactory2_36;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_AnimationDriver_37", {
        get: function () {
            if ((this.__AnimationDriver_37 == null)) {
                (this.__AnimationDriver_37 = __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["a" /* ɵb */]());
            }
            return this.__AnimationDriver_37;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_\u0275AnimationStyleNormalizer_38", {
        get: function () {
            if ((this.__ɵAnimationStyleNormalizer_38 == null)) {
                (this.__ɵAnimationStyleNormalizer_38 = __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["b" /* ɵc */]());
            }
            return this.__ɵAnimationStyleNormalizer_38;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_\u0275AnimationEngine_39", {
        get: function () {
            if ((this.__ɵAnimationEngine_39 == null)) {
                (this.__ɵAnimationEngine_39 = new __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["c" /* ɵa */](this._AnimationDriver_37, this._ɵAnimationStyleNormalizer_38));
            }
            return this.__ɵAnimationEngine_39;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_RendererFactory2_40", {
        get: function () {
            if ((this.__RendererFactory2_40 == null)) {
                (this.__RendererFactory2_40 = __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["d" /* ɵd */](this._ɵDomRendererFactory2_36, this._ɵAnimationEngine_39, this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* NgZone */])));
            }
            return this.__RendererFactory2_40;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_\u0275SharedStylesHost_41", {
        get: function () {
            if ((this.__ɵSharedStylesHost_41 == null)) {
                (this.__ɵSharedStylesHost_41 = this._ɵDomSharedStylesHost_35);
            }
            return this.__ɵSharedStylesHost_41;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Testability_42", {
        get: function () {
            if ((this.__Testability_42 == null)) {
                (this.__Testability_42 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["i" /* Testability */](this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* NgZone */])));
            }
            return this.__Testability_42;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Meta_43", {
        get: function () {
            if ((this.__Meta_43 == null)) {
                (this.__Meta_43 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["k" /* Meta */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__Meta_43;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Title_44", {
        get: function () {
            if ((this.__Title_44 == null)) {
                (this.__Title_44 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["l" /* Title */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["c" /* DOCUMENT */])));
            }
            return this.__Title_44;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_BrowserXhr_45", {
        get: function () {
            if ((this.__BrowserXhr_45 == null)) {
                (this.__BrowserXhr_45 = new __WEBPACK_IMPORTED_MODULE_11__angular_http__["a" /* BrowserXhr */]());
            }
            return this.__BrowserXhr_45;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_ResponseOptions_46", {
        get: function () {
            if ((this.__ResponseOptions_46 == null)) {
                (this.__ResponseOptions_46 = new __WEBPACK_IMPORTED_MODULE_11__angular_http__["b" /* BaseResponseOptions */]());
            }
            return this.__ResponseOptions_46;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_XSRFStrategy_47", {
        get: function () {
            if ((this.__XSRFStrategy_47 == null)) {
                (this.__XSRFStrategy_47 = new __WEBPACK_IMPORTED_MODULE_15__app_shared_tracking_tracking_module__["a" /* NoXSRFStrategy */]());
            }
            return this.__XSRFStrategy_47;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_XHRBackend_48", {
        get: function () {
            if ((this.__XHRBackend_48 == null)) {
                (this.__XHRBackend_48 = new __WEBPACK_IMPORTED_MODULE_11__angular_http__["c" /* XHRBackend */](this._BrowserXhr_45, this._ResponseOptions_46, this._XSRFStrategy_47));
            }
            return this.__XHRBackend_48;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_RequestOptions_49", {
        get: function () {
            if ((this.__RequestOptions_49 == null)) {
                (this.__RequestOptions_49 = new __WEBPACK_IMPORTED_MODULE_11__angular_http__["d" /* BaseRequestOptions */]());
            }
            return this.__RequestOptions_49;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Http_50", {
        get: function () {
            if ((this.__Http_50 == null)) {
                (this.__Http_50 = __WEBPACK_IMPORTED_MODULE_11__angular_http__["e" /* ɵc */](this._XHRBackend_48, this._RequestOptions_49));
            }
            return this.__Http_50;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_REDUX_DEVTOOLS_EXTENSION_51", {
        get: function () {
            if ((this.__REDUX_DEVTOOLS_EXTENSION_51 == null)) {
                (this.__REDUX_DEVTOOLS_EXTENSION_51 = __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["a" /* _createReduxDevtoolsExtension */]());
            }
            return this.__REDUX_DEVTOOLS_EXTENSION_51;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_DevtoolsExtension_52", {
        get: function () {
            if ((this.__DevtoolsExtension_52 == null)) {
                (this.__DevtoolsExtension_52 = new __WEBPACK_IMPORTED_MODULE_16__ngrx_store_devtools_src_extension__["a" /* DevtoolsExtension */](this._REDUX_DEVTOOLS_EXTENSION_51));
            }
            return this.__DevtoolsExtension_52;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_DevtoolsDispatcher_53", {
        get: function () {
            if ((this.__DevtoolsDispatcher_53 == null)) {
                (this.__DevtoolsDispatcher_53 = new __WEBPACK_IMPORTED_MODULE_17__ngrx_store_devtools_src_devtools__["a" /* DevtoolsDispatcher */]());
            }
            return this.__DevtoolsDispatcher_53;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Dispatcher_54", {
        get: function () {
            if ((this.__Dispatcher_54 == null)) {
                (this.__Dispatcher_54 = new __WEBPACK_IMPORTED_MODULE_18__ngrx_store_src_dispatcher__["a" /* Dispatcher */]());
            }
            return this.__Dispatcher_54;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_INITIAL_REDUCER_56", {
        get: function () {
            if ((this.__INITIAL_REDUCER_56 == null)) {
                (this.__INITIAL_REDUCER_56 = __WEBPACK_IMPORTED_MODULE_12__ngrx_store_src_ng2__["a" /* _initialReducerFactory */](this.__INITIAL_REDUCER_55));
            }
            return this.__INITIAL_REDUCER_56;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Reducer_57", {
        get: function () {
            if ((this.__Reducer_57 == null)) {
                (this.__Reducer_57 = __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["b" /* _createReducerIfExtension */](this._REDUX_DEVTOOLS_EXTENSION_51, this, this._INITIAL_REDUCER_56));
            }
            return this.__Reducer_57;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_INITIAL_STATE_59", {
        get: function () {
            if ((this.__INITIAL_STATE_59 == null)) {
                (this.__INITIAL_STATE_59 = __WEBPACK_IMPORTED_MODULE_12__ngrx_store_src_ng2__["b" /* _initialStateFactory */](this.__INITIAL_STATE_58, this._INITIAL_REDUCER_56));
            }
            return this.__INITIAL_STATE_59;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_STORE_DEVTOOLS_CONFIG_61", {
        get: function () {
            if ((this.__STORE_DEVTOOLS_CONFIG_61 == null)) {
                (this.__STORE_DEVTOOLS_CONFIG_61 = __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["c" /* _createOptions */](this._INITIAL_OPTIONS_60));
            }
            return this.__STORE_DEVTOOLS_CONFIG_61;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_StoreDevtools_62", {
        get: function () {
            if ((this.__StoreDevtools_62 == null)) {
                (this.__StoreDevtools_62 = new __WEBPACK_IMPORTED_MODULE_17__ngrx_store_devtools_src_devtools__["b" /* StoreDevtools */](this._DevtoolsDispatcher_53, this._Dispatcher_54, this._Reducer_57, this._DevtoolsExtension_52, this._INITIAL_STATE_59, this._STORE_DEVTOOLS_CONFIG_61));
            }
            return this.__StoreDevtools_62;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_State_63", {
        get: function () {
            if ((this.__State_63 == null)) {
                (this.__State_63 = __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["d" /* _createStateIfExtension */](this._REDUX_DEVTOOLS_EXTENSION_51, this, this._INITIAL_STATE_59));
            }
            return this.__State_63;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Store_64", {
        get: function () {
            if ((this.__Store_64 == null)) {
                (this.__Store_64 = __WEBPACK_IMPORTED_MODULE_12__ngrx_store_src_ng2__["c" /* _storeFactory */](this._Dispatcher_54, this._Reducer_57, this._State_63));
            }
            return this.__Store_64;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_ApiHttp_66", {
        get: function () {
            if ((this.__ApiHttp_66 == null)) {
                (this.__ApiHttp_66 = new __WEBPACK_IMPORTED_MODULE_19__app_shared_datastore_api_http_service__["a" /* ApiHttp */](this._XHRBackend_48, this._RequestOptions_49, this._Auth_5, this._DATASTORE_CONFIG_65));
            }
            return this.__ApiHttp_66;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Store_67", {
        get: function () {
            if ((this.__Store_67 == null)) {
                (this.__Store_67 = __WEBPACK_IMPORTED_MODULE_12__ngrx_store_src_ng2__["c" /* _storeFactory */](this._Dispatcher_54, this._Reducer_57, this._State_63));
            }
            return this.__Store_67;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_WebSocketService_68", {
        get: function () {
            if ((this.__WebSocketService_68 == null)) {
                (this.__WebSocketService_68 = new __WEBPACK_IMPORTED_MODULE_20__app_shared_datastore_websocket_websocket__["a" /* WebSocketService */](this._DATASTORE_CONFIG_65, this._Auth_5, this._Store_67));
            }
            return this.__WebSocketService_68;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Datastore_69", {
        get: function () {
            if ((this.__Datastore_69 == null)) {
                (this.__Datastore_69 = new __WEBPACK_IMPORTED_MODULE_21__app_shared_datastore_datastore__["a" /* Datastore */](this._Store_67, this._ApiHttp_66, this._WebSocketService_68));
            }
            return this.__Datastore_69;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_Tracking_70", {
        get: function () {
            if ((this.__Tracking_70 == null)) {
                (this.__Tracking_70 = new __WEBPACK_IMPORTED_MODULE_22__app_shared_tracking_tracking_service__["a" /* Tracking */](this._Http_50, this._Auth_5, this._CookieService_4, this._TRACKING_CONFIG_6));
            }
            return this.__Tracking_70;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompatModuleInjector.prototype, "_NgModuleFactoryLoader_71", {
        get: function () {
            if ((this.__NgModuleFactoryLoader_71 == null)) {
                (this.__NgModuleFactoryLoader_71 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["j" /* SystemJsNgModuleLoader */](this._Compiler_26, this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["k" /* SystemJsNgModuleLoaderConfig */], null)));
            }
            return this.__NgModuleFactoryLoader_71;
        },
        enumerable: true,
        configurable: true
    });
    CompatModuleInjector.prototype.createInternal = function () {
        this._CommonModule_0 = new __WEBPACK_IMPORTED_MODULE_2__angular_common__["b" /* CommonModule */]();
        this._AUTH_CONFIG_1 = {
            baseUrl: 'https://www.freelancer.com/auth',
            authHashCookie: 'GETAFREE_AUTH_HASH_V2',
            userIdCookie: 'GETAFREE_USER_ID'
        };
        this._COOKIE_OPTIONS_2 = {};
        this._CookieOptionsProvider_3 = new __WEBPACK_IMPORTED_MODULE_3_ngx_cookie_src_cookie_options_provider__["a" /* CookieOptionsProvider */](this._COOKIE_OPTIONS_2, this);
        this._CookieService_4 = __WEBPACK_IMPORTED_MODULE_25_ngx_cookie_src_cookie_factory__["a" /* cookieServiceFactory */](this._CookieOptionsProvider_3);
        this._Auth_5 = new __WEBPACK_IMPORTED_MODULE_4__app_shared_auth_auth_service__["a" /* Auth */](this._AUTH_CONFIG_1, this._CookieService_4);
        this._TRACKING_CONFIG_6 = {
            trackingEndpoint: 'https://t.freelancer.com/0px.gif',
            sessionCookie: '_tracking_session',
            navigationPerformanceSamplingRate: 1,
            enableErrorTracking: true,
            sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
            gitRevision: '4d638d6bc75',
            buildDate: 'Fri Jun 23 2017 04:22:48 GMT-0400 (EDT)'
        };
        this._ErrorTracking_7 = new __WEBPACK_IMPORTED_MODULE_5__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */](this._Auth_5, this._TRACKING_CONFIG_6);
        this._ErrorHandler_8 = new __WEBPACK_IMPORTED_MODULE_6__app_shared_tracking_custom_error_handler_service__["a" /* CustomErrorHandler */](this._ErrorTracking_7);
        this._APP_INITIALIZER_9 = [
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["l" /* ɵo */],
            __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["m" /* ɵc */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["n" /* NgProbeToken */], null), this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["m" /* NgProbeToken */], null))
        ];
        this._ApplicationInitStatus_10 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["n" /* ApplicationInitStatus */](this._APP_INITIALIZER_9);
        this._ɵf_11 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* ɵf */](this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["h" /* NgZone */]), this.parent.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["p" /* ɵConsole */]), this, this._ErrorHandler_8, this.componentFactoryResolver, this._ApplicationInitStatus_10);
        this._ApplicationRef_12 = this._ɵf_11;
        this._ApplicationModule_13 = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["q" /* ApplicationModule */](this._ApplicationRef_12);
        this._BrowserModule_14 = new __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["o" /* BrowserModule */](this.parent.get(__WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["o" /* BrowserModule */], null));
        this._BrowserAnimationsModule_15 = new __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["e" /* BrowserAnimationsModule */]();
        this._CookieModule_16 = new __WEBPACK_IMPORTED_MODULE_9_ngx_cookie_index__["a" /* CookieModule */]();
        this._AuthModule_17 = new __WEBPACK_IMPORTED_MODULE_10__app_shared_auth_auth_module__["a" /* AuthModule */]();
        this._HttpModule_18 = new __WEBPACK_IMPORTED_MODULE_11__angular_http__["f" /* HttpModule */]();
        this._StoreModule_19 = new __WEBPACK_IMPORTED_MODULE_12__ngrx_store_src_ng2__["d" /* StoreModule */]();
        this._StoreDevtoolsModule_20 = new __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["e" /* StoreDevtoolsModule */]();
        this._DatastoreModule_21 = new __WEBPACK_IMPORTED_MODULE_14__app_shared_datastore_datastore_module__["a" /* DatastoreModule */]();
        this._TrackingModule_22 = new __WEBPACK_IMPORTED_MODULE_15__app_shared_tracking_tracking_module__["b" /* TrackingModule */]();
        this._CompatModule_23 = new __WEBPACK_IMPORTED_MODULE_1__compat_compat_module__["a" /* CompatModule */]();
        this.__INITIAL_REDUCER_55 = __WEBPACK_IMPORTED_MODULE_26__app_shared_datastore_store__["a" /* store */];
        this.__INITIAL_STATE_58 = undefined;
        this._INITIAL_OPTIONS_60 = { maxAge: 5 };
        this._DATASTORE_CONFIG_65 = {
            apiBaseUrl: 'https://www.freelancer.com/api',
            ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
            webSocketUrl: 'https://notifications.freelancer.com'
        };
        this._ROUTES_72 = [[
                {
                    selector: 'webapp-compat-tracking',
                    loadChildren: 'app/@shared/tracking/tracking.module#TrackingModule',
                    component: __WEBPACK_IMPORTED_MODULE_27__app_shared_tracking_tracking_component__["a" /* TrackingComponent */],
                    path: 'hack_path_not_used'
                },
                {
                    selector: 'webapp-compat-navigation',
                    loadChildren: 'compat/compat-navigation.module#CompatNavigationModule',
                    component: __WEBPACK_IMPORTED_MODULE_28__compat_compat_navigation_component__["a" /* CompatNavigationComponent */],
                    path: 'hack_path_not_used'
                }
            ]
        ];
        return this._CompatModule_23;
    };
    CompatModuleInjector.prototype.getInternal = function (token, notFoundResult) {
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_common__["b" /* CommonModule */])) {
            return this._CommonModule_0;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_29__app_shared_auth_auth_config__["a" /* AUTH_CONFIG */])) {
            return this._AUTH_CONFIG_1;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3_ngx_cookie_src_cookie_options_provider__["b" /* COOKIE_OPTIONS */])) {
            return this._COOKIE_OPTIONS_2;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_3_ngx_cookie_src_cookie_options_provider__["a" /* CookieOptionsProvider */])) {
            return this._CookieOptionsProvider_3;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_30_ngx_cookie_src_cookie_service__["a" /* CookieService */])) {
            return this._CookieService_4;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_4__app_shared_auth_auth_service__["a" /* Auth */])) {
            return this._Auth_5;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_31__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */])) {
            return this._TRACKING_CONFIG_6;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_5__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */])) {
            return this._ErrorTracking_7;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["r" /* ErrorHandler */])) {
            return this._ErrorHandler_8;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["s" /* APP_INITIALIZER */])) {
            return this._APP_INITIALIZER_9;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["n" /* ApplicationInitStatus */])) {
            return this._ApplicationInitStatus_10;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["o" /* ɵf */])) {
            return this._ɵf_11;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["t" /* ApplicationRef */])) {
            return this._ApplicationRef_12;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["q" /* ApplicationModule */])) {
            return this._ApplicationModule_13;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["o" /* BrowserModule */])) {
            return this._BrowserModule_14;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_8__angular_platform_browser_animations__["e" /* BrowserAnimationsModule */])) {
            return this._BrowserAnimationsModule_15;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_9_ngx_cookie_index__["a" /* CookieModule */])) {
            return this._CookieModule_16;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_10__app_shared_auth_auth_module__["a" /* AuthModule */])) {
            return this._AuthModule_17;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_11__angular_http__["f" /* HttpModule */])) {
            return this._HttpModule_18;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_12__ngrx_store_src_ng2__["d" /* StoreModule */])) {
            return this._StoreModule_19;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_13__ngrx_store_devtools_src_instrument__["e" /* StoreDevtoolsModule */])) {
            return this._StoreDevtoolsModule_20;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_14__app_shared_datastore_datastore_module__["a" /* DatastoreModule */])) {
            return this._DatastoreModule_21;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_15__app_shared_tracking_tracking_module__["b" /* TrackingModule */])) {
            return this._TrackingModule_22;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_1__compat_compat_module__["a" /* CompatModule */])) {
            return this._CompatModule_23;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["c" /* LOCALE_ID */])) {
            return this._LOCALE_ID_24;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_2__angular_common__["c" /* NgLocalization */])) {
            return this._NgLocalization_25;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["d" /* Compiler */])) {
            return this._Compiler_26;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["u" /* APP_ID */])) {
            return this._APP_ID_27;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["v" /* IterableDiffers */])) {
            return this._IterableDiffers_28;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["w" /* KeyValueDiffers */])) {
            return this._KeyValueDiffers_29;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["p" /* DomSanitizer */])) {
            return this._DomSanitizer_30;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["x" /* Sanitizer */])) {
            return this._Sanitizer_31;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["q" /* HAMMER_GESTURE_CONFIG */])) {
            return this._HAMMER_GESTURE_CONFIG_32;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["r" /* EVENT_MANAGER_PLUGINS */])) {
            return this._EVENT_MANAGER_PLUGINS_33;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["h" /* EventManager */])) {
            return this._EventManager_34;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["i" /* ɵDomSharedStylesHost */])) {
            return this._ɵDomSharedStylesHost_35;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["j" /* ɵDomRendererFactory2 */])) {
            return this._ɵDomRendererFactory2_36;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_32__angular_animations_browser__["a" /* AnimationDriver */])) {
            return this._AnimationDriver_37;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_32__angular_animations_browser__["b" /* ɵAnimationStyleNormalizer */])) {
            return this._ɵAnimationStyleNormalizer_38;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_32__angular_animations_browser__["c" /* ɵAnimationEngine */])) {
            return this._ɵAnimationEngine_39;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["y" /* RendererFactory2 */])) {
            return this._RendererFactory2_40;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["s" /* ɵSharedStylesHost */])) {
            return this._ɵSharedStylesHost_41;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["i" /* Testability */])) {
            return this._Testability_42;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["k" /* Meta */])) {
            return this._Meta_43;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_7__angular_platform_browser__["l" /* Title */])) {
            return this._Title_44;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_11__angular_http__["a" /* BrowserXhr */])) {
            return this._BrowserXhr_45;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_11__angular_http__["g" /* ResponseOptions */])) {
            return this._ResponseOptions_46;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_11__angular_http__["h" /* XSRFStrategy */])) {
            return this._XSRFStrategy_47;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_11__angular_http__["c" /* XHRBackend */])) {
            return this._XHRBackend_48;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_11__angular_http__["i" /* RequestOptions */])) {
            return this._RequestOptions_49;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_11__angular_http__["j" /* Http */])) {
            return this._Http_50;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_16__ngrx_store_devtools_src_extension__["b" /* REDUX_DEVTOOLS_EXTENSION */])) {
            return this._REDUX_DEVTOOLS_EXTENSION_51;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_16__ngrx_store_devtools_src_extension__["a" /* DevtoolsExtension */])) {
            return this._DevtoolsExtension_52;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_17__ngrx_store_devtools_src_devtools__["a" /* DevtoolsDispatcher */])) {
            return this._DevtoolsDispatcher_53;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_18__ngrx_store_src_dispatcher__["a" /* Dispatcher */])) {
            return this._Dispatcher_54;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_12__ngrx_store_src_ng2__["e" /* _INITIAL_REDUCER */])) {
            return this.__INITIAL_REDUCER_55;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_12__ngrx_store_src_ng2__["f" /* INITIAL_REDUCER */])) {
            return this._INITIAL_REDUCER_56;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_33__ngrx_store_src_reducer__["a" /* Reducer */])) {
            return this._Reducer_57;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_12__ngrx_store_src_ng2__["g" /* _INITIAL_STATE */])) {
            return this.__INITIAL_STATE_58;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_12__ngrx_store_src_ng2__["h" /* INITIAL_STATE */])) {
            return this._INITIAL_STATE_59;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_34__ngrx_store_devtools_src_config__["a" /* INITIAL_OPTIONS */])) {
            return this._INITIAL_OPTIONS_60;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_34__ngrx_store_devtools_src_config__["b" /* STORE_DEVTOOLS_CONFIG */])) {
            return this._STORE_DEVTOOLS_CONFIG_61;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_17__ngrx_store_devtools_src_devtools__["b" /* StoreDevtools */])) {
            return this._StoreDevtools_62;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_35__ngrx_store_src_state__["a" /* State */])) {
            return this._State_63;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_36__ngrx_store_src_store__["a" /* Store */])) {
            return this._Store_64;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_37__app_shared_datastore_datastore_config__["a" /* DATASTORE_CONFIG */])) {
            return this._DATASTORE_CONFIG_65;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_19__app_shared_datastore_api_http_service__["a" /* ApiHttp */])) {
            return this._ApiHttp_66;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_26__app_shared_datastore_store__["b" /* Store */])) {
            return this._Store_67;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_20__app_shared_datastore_websocket_websocket__["a" /* WebSocketService */])) {
            return this._WebSocketService_68;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_21__app_shared_datastore_datastore__["a" /* Datastore */])) {
            return this._Datastore_69;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_22__app_shared_tracking_tracking_service__["a" /* Tracking */])) {
            return this._Tracking_70;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_0__angular_core__["z" /* NgModuleFactoryLoader */])) {
            return this._NgModuleFactoryLoader_71;
        }
        if ((token === __WEBPACK_IMPORTED_MODULE_38__angular_router__["a" /* ROUTES */])) {
            return this._ROUTES_72;
        }
        return notFoundResult;
    };
    CompatModuleInjector.prototype.destroyInternal = function () {
        this._ɵf_11.ngOnDestroy();
        (this.__ɵDomSharedStylesHost_35 && this._ɵDomSharedStylesHost_35.ngOnDestroy());
    };
    return CompatModuleInjector;
}(__WEBPACK_IMPORTED_MODULE_0__angular_core__["A" /* ɵNgModuleInjector */]));
var CompatModuleNgFactory = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["B" /* NgModuleFactory */](CompatModuleInjector, __WEBPACK_IMPORTED_MODULE_1__compat_compat_module__["a" /* CompatModule */]);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0Lm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=
//# sourceMappingURL=compat.module.ngfactory.js.map

/***/ }),

/***/ "Cuc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("bKWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_user_reducer__ = __webpack_require__("6tnj");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return threadReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return threadUnreadCountReducer; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};


var threadReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload && action.payload.ref.path[0] === 'threads') {
                var ref = action.payload.ref;
                // action.payload.ref.path[1] is the user. Use it for now.
                var selfId_1 = Number(ref.path[1]);
                var data = action.payload.data;
                // Denormalize the Thread API response
                var contextDetails_1 = data.context_details;
                var users_1 = data.users;
                var threads = data.threads.reduce(
                // FIXME: thread: any inference needs to go. ContextApi is incorrect.
                function (acc, thread) {
                    var context = __assign({}, thread.thread.context);
                    if (context) {
                        if (context.type === 'project') {
                            context.project = contextDetails_1.projects[context.id];
                        }
                        else if (context.type === 'contest') {
                            context.contest = contextDetails_1.contests[context.id];
                        }
                        context.id = undefined;
                    }
                    var members = thread.thread.members.map(function (memberId) {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__user_user_reducer__["a" /* transformUser */])(users_1[memberId]);
                    });
                    var owner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__user_user_reducer__["a" /* transformUser */])(users_1[thread.thread.owner]);
                    var title = '';
                    var subtitle = '';
                    var membersString = thread.thread.members
                        .filter(function (userId) { return userId !== selfId_1; })
                        .map(function (userId) { return users_1[userId].username; })
                        .join(', ');
                    title = membersString;
                    if (thread.thread.context &&
                        thread.thread.context.type === 'project' &&
                        contextDetails_1.projects[thread.thread.context.id]) {
                        title = contextDetails_1.projects[thread.thread.context.id].title;
                        subtitle = membersString;
                    }
                    var threadInner = __assign({}, thread.thread, { context: context,
                        members: members,
                        owner: owner,
                        title: title,
                        subtitle: subtitle });
                    var messages = thread.messages &&
                        thread.messages.map(function (message) {
                            return __assign({}, message, { fromUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__user_user_reducer__["a" /* transformUser */])(users_1[message.from_user]) });
                        });
                    acc[thread.id] = __assign({}, thread, { thread: threadInner, time_read: thread.time_read * 1000, time_updated: thread.time_updated * 1000, messages: messages });
                    return acc;
                }, {});
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, threads, ref);
            }
            return state;
        /*case 'WEBSOCKET_LOAD_SUCCESS':
          const threadId: any = action.payload.thread_id;
          let newThreads: any = {};
          const thread: any = state[threadId];
          if (!thread) {
            return state;
          }
          const now = Date.now();
          const newTimeUpdated: any = { time_updated: now };
          newThreads[threadId] = Object.assign({}, thread, newTimeUpdated);
          return Object.assign({}, state, newThreads);*/
        default:
            return state;
    }
};
var threadUnreadCountReducer = function (state, action) {
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'threadUnreadCount') {
                var _a = action.payload, data = _a.data, ref = _a.ref;
                //  return mergeEntities(state, data.unread_thread_count, ref);
                return state;
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=thread.reducer.js.map

/***/ }),

/***/ "EVHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_service__ = __webpack_require__("sVtB");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserTimingTrackingComponent; });

var UserTimingTrackingComponent = (function () {
    function UserTimingTrackingComponent(t) {
        this.t = t;
        this.timingMarkOffset = 0; // keep track of the timing marks already reported
    }
    UserTimingTrackingComponent.prototype.ngOnInit = function () {
        // Only enable if the browser supports the User Timing API
        // (http://caniuse.com/#feat=user-timing)
        if (!(window.performance && window.performance.getEntriesByType)) {
            return;
        }
        this.reportTimingMarks();
    };
    UserTimingTrackingComponent.prototype.reportTimingMarks = function () {
        var _this = this;
        window.requestIdleCallback(function () {
            var marks = window.performance.getEntriesByType('mark');
            if (marks.length > _this.timingMarkOffset) {
                for (var i = _this.timingMarkOffset; i < marks.length; i++) {
                    var mark = marks[i];
                    var t = Math.round(mark.startTime);
                    if (t >= 0 && t < 3600000) {
                        var p = {
                            mark_name: mark.name,
                            mark_time: t,
                        };
                        _this.t.track('user_timing', p);
                    }
                    _this.timingMarkOffset += marks.length;
                }
            }
            // Use the Page Visibility API to stop the collection if available
            if (document.hidden) {
                var onVisible_1 = function () {
                    document.removeEventListener('visibilitychange', onVisible_1);
                    setTimeout(function () { return _this.reportTimingMarks(); }, 1000);
                };
                document.addEventListener('visibilitychange', onVisible_1);
            }
            else {
                // TODO: User PerformanceObserver when it's more widely supported
                setTimeout(function () { return _this.reportTimingMarks(); }, 1000);
            }
        });
    };
    UserTimingTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__tracking_service__["a" /* Tracking */] }]; };
    return UserTimingTrackingComponent;
}());

//# sourceMappingURL=user-timing-tracking.component.js.map

/***/ }),

/***/ "F5VT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_combineLatest__ = __webpack_require__("XlOA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_combineLatest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_combineLatest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_concat__ = __webpack_require__("1ZrL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_empty__ = __webpack_require__("AGQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_from__ = __webpack_require__("S35O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_interval__ = __webpack_require__("SUuD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_interval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_interval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_merge__ = __webpack_require__("fICK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of__ = __webpack_require__("1APj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_throw__ = __webpack_require__("h0qH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_throw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_throw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_bufferTime__ = __webpack_require__("Di9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_bufferTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_bufferTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_catch__ = __webpack_require__("6Yye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_combineLatest__ = __webpack_require__("qp8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_combineLatest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_combineLatest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_concat__ = __webpack_require__("/rMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_debounceTime__ = __webpack_require__("aV5h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_debounceTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_debounceTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_distinctUntilChanged__ = __webpack_require__("q3ik");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_distinctUntilChanged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_distinctUntilChanged__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_do__ = __webpack_require__("EnA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_do___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_do__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_filter__ = __webpack_require__("wUn1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_first__ = __webpack_require__("okk1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_mapTo__ = __webpack_require__("6gFN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_mapTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_mapTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_merge__ = __webpack_require__("EGMK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mergeMap__ = __webpack_require__("HcJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_multicast__ = __webpack_require__("j7ye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_multicast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_multicast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_pluck__ = __webpack_require__("xOQQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_pluck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_pluck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_scan__ = __webpack_require__("zJQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_scan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_scan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_startWith__ = __webpack_require__("/lY3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_startWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_startWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_switchMap__ = __webpack_require__("uCY4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_switchMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_take__ = __webpack_require__("hzF8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_toPromise__ = __webpack_require__("eErF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_withLatestFrom__ = __webpack_require__("fiy1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_withLatestFrom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_withLatestFrom__);
// See node_module/rxjs/Rxjs.js
// Import just the rxjs statics and operators needed for THIS app.
// Statics








// Operators





















//# sourceMappingURL=rxjs-operators.js.map

/***/ }),

/***/ "LV28":
/***/ (function(module, exports) {

//# sourceMappingURL=auth.interface.js.map

/***/ }),

/***/ "LaRx":
/***/ (function(module, exports) {

//# sourceMappingURL=datastore.interface.js.map

/***/ }),

/***/ "MmZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("bKWi");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messageReducer; });

var messageReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            {
                if (action.payload && action.payload.ref.path[0] === 'messages') {
                    var _a = action.payload, data = _a.data, ref = _a.ref;
                    var messages = data.messages.reduce(function (acc, message) {
                        acc[message.id] = message;
                        return acc;
                    }, {});
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, messages, ref);
                }
            }
            return state;
        case 'API_POST':
        case 'API_POST_SUCCESS': {
            if (action.payload && action.payload.ref.path[0] === 'messages') {
                var _b = action.payload, message = _b.data, ref = _b.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, (_c = {}, _c[message.id] = message, _c), ref);
            }
            return state;
        }
        /*case 'RECEIVED_MESSAGE_FROM_SOCKET': {
          const oldMessage = state[action.payload.thread_id].filter((
            (message: any) => ((
              message.client_message_id === action.payload.client_message_id
            ))
          ))[0] || {};
          const messageList: Array<any> = (state[action.payload.thread_id] || [])
            .filter((message: any) => (
              message.client_message_id !== action.payload.client_message_id
            ));
          messageList.push(Object.assign({}, oldMessage, action.payload));
    
          const threadId: any = action.payload.thread_id;
          let newThreads: any = {};
          newThreads[threadId] = messageList;
          return Object.assign({}, state, newThreads);
        }*/
        default:
            return state;
    }
    var _c;
};
//# sourceMappingURL=message.reducer.js.map

/***/ }),

/***/ "OTuB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_service__ = __webpack_require__("TZHD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth_config__ = __webpack_require__("Tz6n");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthModule; });


var AuthModule = (function () {
    function AuthModule() {
    }
    AuthModule.initialize = function (config) {
        return {
            ngModule: AuthModule,
            providers: [__WEBPACK_IMPORTED_MODULE_0__auth_service__["a" /* Auth */], { provide: __WEBPACK_IMPORTED_MODULE_1__auth_config__["a" /* AUTH_CONFIG */], useValue: config }],
        };
    };
    return AuthModule;
}());

//# sourceMappingURL=auth.module.js.map

/***/ }),

/***/ "OoH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return backend; });
var backend = {
    giveGetEligibility: {
        fetch: function () { return ({
            endpoint: "users/0.1/referral_invitations/check",
            params: {
                bonus_id: '16',
            },
        }); },
    },
    messages: {
        fetch: function (key) { return ({
            endpoint: "messages/0.1/messages",
            params: { 'threads[]': key },
        }); },
        post: function (key) { return ({
            endpoint: "messages/0.1/threads/" + key + "/messages/",
            params: {
                thread_id: key,
            },
        }); },
    },
    navigationNotifications: {
        fetch: function () { return ({
            endpoint: "newsfeed/0.1/newsfeed/notifications",
            params: {},
        }); },
    },
    navigationProjectFeed: {
        fetch: function () { return ({
            endpoint: "navigation/project-feed/pre-populated.php",
            isGaf: true,
            params: {},
        }); },
    },
    navigationProjectFeedFailingProjects: {
        fetch: function () { return ({
            endpoint: "navigation/project-feed/pre-populated-xp-projectcontest.php",
            isGaf: true,
            params: { type: 'p' },
        }); },
    },
    navigationProjectFeedFailingContests: {
        fetch: function () { return ({
            endpoint: "navigation/project-feed/pre-populated-xp-projectcontest.php",
            isGaf: true,
            params: { type: 'c' },
        }); },
    },
    navigationUserBalances: {
        fetch: function () { return ({
            endpoint: "users/0.1/self",
            params: { balance_details: 1 },
        }); },
    },
    navigationUserInfo: {
        fetch: function () { return ({
            endpoint: "navigation/user-info.php",
            isGaf: true,
            params: {},
        }); },
    },
    navigationUserRecentProjectsAndContests: {
        fetch: function () { return ({
            endpoint: "navigation/recent-projects-and-contests.php",
            isGaf: true,
            params: {},
        }); },
    },
    notificationsUserPreferences: {
        fetch: function () { return ({
            endpoint: "notifications/preferences.php",
            isGaf: true,
            params: {},
        }); },
        post: function (key) { return ({
            endpoint: "notifications/set-preferences.php",
            isGaf: true,
        }); },
    },
    onlineOffline: {},
    threads: {
        fetch: function (key) { return ({
            endpoint: "messages/0.1/threads",
            params: {
                unread_count: 'true',
                last_message: 'true',
                message_details: 'true',
                context_details: 'true',
                user_details: 'true',
            },
        }); },
    },
    threadUnreadCount: {},
};
//# sourceMappingURL=backend.js.map

/***/ }),

/***/ "PzJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackingComponent; });
var TrackingComponent = (function () {
    function TrackingComponent() {
    }
    return TrackingComponent;
}());

//# sourceMappingURL=tracking.component.js.map

/***/ }),

/***/ "Qotf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sockjs_client__ = __webpack_require__("O3w4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sockjs_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sockjs_client__);
/* harmony export (immutable) */ __webpack_exports__["c"] = generateUserSub;
/* harmony export (immutable) */ __webpack_exports__["e"] = generateUserUnsub;
/* harmony export (immutable) */ __webpack_exports__["d"] = generateChannelSubMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = generateHeader;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Socket; });
/* A wrapper around SockJS so that we make sure that we only
 * send messages of types that our backend supports.
 *
 * Contains both the types of messages sent and received as well as
 * helper functions to construct these.
 */

var State;
(function (State) {
    State[State["CONNECTING"] = 0] = "CONNECTING";
    State[State["OPEN"] = 1] = "OPEN";
    State[State["CLOSING"] = 2] = "CLOSING";
    State[State["CLOSED"] = 3] = "CLOSED";
})(State || (State = {}));
function generateUserSub(userIds) {
    return {
        channel: 'onlineoffline',
        body: {
            route: 'getsub',
            users: userIds,
        },
    };
}
function generateUserUnsub(userIds) {
    return {
        channel: 'onlineoffline',
        body: {
            route: 'unsub',
            users: userIds,
        },
    };
}
function generateChannelSubMessage(channels) {
    return {
        channel: 'channels',
        body: { channels: channels },
    };
}
function generateHeader(auth) {
    return {
        channel: 'auth',
        body: {
            hash2: auth.token,
            user_id: auth.uid,
        },
    };
}
var Socket = (function () {
    function Socket(url) {
        var _this = this;
        this.sock = new __WEBPACK_IMPORTED_MODULE_0_sockjs_client__(url);
        this.sock.onopen = function (e) { return _this.onopen(e); };
        this.sock.onclose = function (e) { return _this.onclose(e); };
        this.sock.onmessage = function (e) { return _this.onmessage(e); };
    }
    Socket.prototype.readyState = function () {
        return this.sock.readyState;
    };
    Socket.prototype.send = function (message) {
        this.sock.send(JSON.stringify(message));
    };
    Socket.prototype.close = function (code, reason) {
        this.sock.close(code, reason);
    };
    return Socket;
}());

//# sourceMappingURL=sock-js.js.map

/***/ }),

/***/ "SPEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_synthetic_performance_tracking_component__ = __webpack_require__("yUzi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngx_cookie_src_cookie_service__ = __webpack_require__("A+9r");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_SyntheticPerformanceTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_SyntheticPerformanceTrackingComponent_0;
/* unused harmony export SyntheticPerformanceTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_SyntheticPerformanceTrackingComponent = [];
var RenderType_SyntheticPerformanceTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_SyntheticPerformanceTrackingComponent,
    data: {}
});
function View_SyntheticPerformanceTrackingComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [(l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_SyntheticPerformanceTrackingComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 1, 'fl-synthetic-performance-tracking', [], null, null, null, View_SyntheticPerformanceTrackingComponent_0, RenderType_SyntheticPerformanceTrackingComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_33" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_synthetic_performance_tracking_component__["a" /* SyntheticPerformanceTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_2_ngx_cookie_src_cookie_service__["a" /* CookieService */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["_21" /* Renderer2 */]
        ], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var SyntheticPerformanceTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_34" /* ɵccf */]('fl-synthetic-performance-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_synthetic_performance_tracking_component__["a" /* SyntheticPerformanceTrackingComponent */], View_SyntheticPerformanceTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvc3ludGhldGljLXBlcmZvcm1hbmNlLXRyYWNraW5nLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3N5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3N5bnRoZXRpYy1wZXJmb3JtYW5jZS10cmFja2luZy5jb21wb25lbnQudHMuU3ludGhldGljUGVyZm9ybWFuY2VUcmFja2luZ0NvbXBvbmVudC5odG1sIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmcuY29tcG9uZW50LnRzLlN5bnRoZXRpY1BlcmZvcm1hbmNlVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+PC9mbC1zeW50aGV0aWMtcGVyZm9ybWFuY2UtdHJhY2tpbmc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt5QkNBQTs7OztJQ0FBO2dCQUFBOzs7SUFBQTtLQUFBOzs7SUFBQTs7OyJ9
//# sourceMappingURL=synthetic-performance-tracking.component.ngfactory.js.map

/***/ }),

/***/ "TZHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_cookie__ = __webpack_require__("VffS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__ = __webpack_require__("MQMf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth_config__ = __webpack_require__("Tz6n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_interface__ = __webpack_require__("LV28");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__auth_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Auth; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Auth = (function (_super) {
    __extends(Auth, _super);
    function Auth(authConfig, cookies) {
        var _this = _super.call(this, 1) || this;
        _this.authConfig = authConfig;
        _this.cookies = cookies;
        var uid = parseInt(_this.cookies.get(_this.authConfig.userIdCookie), 10);
        var token = _this.cookies.get(_this.authConfig.authHashCookie);
        _this.next({ uid: uid, token: token });
        return _this;
    }
    Auth.prototype.setState = function (uid, token) {
        this.cookies.put(this.authConfig.userIdCookie, uid.toString());
        this.cookies.put(this.authConfig.authHashCookie, token);
        this.next({ uid: uid, token: token });
    };
    /*login(): Promise<void> {
      // TODO
    }
  
    logout(): Promise<void> {
      // TODO
      // this.next({});
    }*/
    Auth.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_4__auth_interface__["AuthConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_3__auth_config__["a" /* AUTH_CONFIG */]] }] }, { type: __WEBPACK_IMPORTED_MODULE_1__shared_cookie__["a" /* CookieService */] }]; };
    return Auth;
}(__WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__["ReplaySubject"]));

//# sourceMappingURL=auth.service.js.map

/***/ }),

/***/ "Tz6n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_CONFIG; });

var AUTH_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["_20" /* OpaqueToken */]('AuthConfig');
//# sourceMappingURL=auth.config.js.map

/***/ }),

/***/ "UbRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_tracking_service__ = __webpack_require__("maH+");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomErrorHandler; });

var CustomErrorHandler = (function () {
    function CustomErrorHandler(errorTracking) {
        this.errorTracking = errorTracking;
    }
    CustomErrorHandler.prototype.handleError = function (error) {
        this.errorTracking.captureException(error);
    };
    CustomErrorHandler.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_0__error_tracking_service__["a" /* ErrorTracking */] }]; };
    return CustomErrorHandler;
}());

//# sourceMappingURL=custom-error-handler.service.js.map

/***/ }),

/***/ "VaD5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjectObservable; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ObjectObservable = (function (_super) {
    __extends(ObjectObservable, _super);
    function ObjectObservable(ref$, apiHttp, store, source) {
        var _this = _super.call(this) || this;
        _this.ref$ = ref$;
        _this.apiHttp = apiHttp;
        _this.store = store;
        _this.source = source;
        return _this;
    }
    ObjectObservable.prototype.lift = function (operator) {
        var observable = new ObjectObservable(this.ref$, this.apiHttp, this.store, this);
        observable.operator = operator;
        return observable;
    };
    ObjectObservable.prototype.set = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(undefined);
    };
    ObjectObservable.prototype.update = function (value) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(undefined);
    };
    ObjectObservable.prototype.remove = function () {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(undefined);
    };
    return ObjectObservable;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"]));

//# sourceMappingURL=object-observable.js.map

/***/ }),

/***/ "VffS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ngx_cookie__ = __webpack_require__("9db2");
/* unused harmony reexport CookieModule */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_ngx_cookie__["b"]; });
// We use https://github.com/salemdar/ngx-cookie, refer to the API docs there.

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "ZbSj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("bKWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transformers__ = __webpack_require__("7Aw9");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationUserRecentProjectsAndContestsReducer; });


var navigationUserRecentProjectsAndContestsReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationUserRecentProjectsAndContests') {
                var ref = action.payload.ref;
                var data = action.payload.data;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transformers__["a" /* transformUserRecentProjectsAndContests */])(data), ref);
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=userRecentProjectsAndContests.js.map

/***/ }),

/***/ "aDql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("bKWi");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return notificationsUserPreferencesReducer; });

var notificationsUserPreferencesReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'notificationsUserPreferences') {
                var _a = action.payload, data = _a.data, ref = _a.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, transformNotificationsUserPreferences(data), ref);
            }
            return state;
        case 'API_POST_SUCCESS': {
            if (action.payload &&
                action.payload.ref.path[0] === 'notificationsUserPreferences') {
                var _b = action.payload, data = _b.data, ref = _b.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, transformNotificationsUserPreferences(data), ref);
            }
            return state;
        }
        default:
            return state;
    }
};
function transformNotificationsUserPreferences(data) {
    return data.reduce(function (obj, setting) {
        obj[setting.channel] = {
            channel: setting.channel,
            name: setting.name,
            order: setting.order,
            enabled: setting.enabled,
            notify: setting.notify,
            header: setting.header,
            notificationType: setting.notificationType,
        };
        return obj;
    }, {});
}
//# sourceMappingURL=notifications.reducer.js.map

/***/ }),

/***/ "bKWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_store__ = __webpack_require__("WWmu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose__ = __webpack_require__("owqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze__ = __webpack_require__("KhQu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__message_message_reducer__ = __webpack_require__("MmZW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__ = __webpack_require__("iQnU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__give_get_give_get_reducer__ = __webpack_require__("jD7Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__online_offline_online_offline_reducer__ = __webpack_require__("3iA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__thread_thread_reducer__ = __webpack_require__("Cuc0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notifications_notifications_reducer__ = __webpack_require__("aDql");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Store; });
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeEntities;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeEntity;
/* harmony export (immutable) */ __webpack_exports__["a"] = store;
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};









/* Wrap ngrx's Store as our own Store that only takes our action types. */
var Store = (function (_super) {
    __extends(Store, _super);
    function Store() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Store.prototype.dispatch = function (action) {
        _super.prototype.dispatch.call(this, action);
    };
    Store.prototype.next = function (action) {
        _super.prototype.next.call(this, action);
    };
    return Store;
}(__WEBPACK_IMPORTED_MODULE_0__ngrx_store__["a" /* Store */]));

var spaceship = function (a, b) { return (a < b ? -1 : a > b ? 1 : 0); };
function arrayMerge(a, b) {
    var result = [];
    var max = Math.max(a.length, b.length);
    for (var i = 0; i < max; i++) {
        if (a[i] || b[i]) {
            result[i] = a[i] || b[i];
        }
    }
    return result;
}
function arrayShift(a, offset) {
    return new Array(offset).concat(a);
}
/* This merges a number of entities into the state.
 * If an offset it specified then the new entities are placed at that offset.
 * If an offset is not specified then the new entities will be:
 *   - merged if they have the same id as an existing entity OR
 *   - placed at the start of the list (and the offset of existing items moved up)
 *
 * We also allow a custom sorting function to allow resorting the list.
 * If this is used all the offsets will be then be reindexed from 0.
 */
function mergeEntities(state, entities, ref, sortKey) {
    var data = state[ref.path[1]] || { entities: {} };
    var query = 'default'; // FIXME
    var originalList = data.lists ? data.lists[query].slice() || [] : [];
    var updatedEntities = __assign({}, data.entities, entities);
    var newEntityIds = Object.keys(updatedEntities).filter(function (key) { return !Object.keys(data.entities).includes(key); });
    // If the new list doesn't have an offset then the new list is put at the front.
    var originalListOffset = ref.query && ref.query.offset
        ? 0
        : newEntityIds.length;
    var newListOffset = (ref.query && ref.query.offset) || 0;
    var updatedQueryList = arrayMerge(arrayShift(originalList, originalListOffset), arrayShift(newEntityIds, newListOffset));
    if (sortKey) {
        updatedQueryList.sort(function (a, b) {
            return spaceship(updatedEntities[a][sortKey], updatedEntities[b][sortKey]);
        });
    }
    return Object.assign({}, state, (_a = {},
        _a[ref.path[1]] = {
            entities: updatedEntities,
            lists: __assign({}, data.lists, (_b = {}, _b[query] = updatedQueryList, _b)),
        },
        _a));
    var _a, _b;
}
function mergeEntity(state, entity, path) {
    return Object.assign({}, state, (_a = {}, _a[path[1]] = entity, _a));
    var _a;
}
function store(state, action) {
    var reducers = {
        giveGetEligibility: __WEBPACK_IMPORTED_MODULE_5__give_get_give_get_reducer__["a" /* giveGetEligibilityReducer */],
        messages: __WEBPACK_IMPORTED_MODULE_3__message_message_reducer__["a" /* messageReducer */],
        navigationNotifications: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["a" /* navigationNotificationsReducer */],
        navigationProjectFeed: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["b" /* navigationProjectFeedReducer */],
        navigationProjectFeedFailingContests: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["c" /* navigationProjectFeedFailingContestsReducer */],
        navigationProjectFeedFailingProjects: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["d" /* navigationProjectFeedFailingProjectsReducer */],
        navigationUserBalances: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["e" /* navigationUserBalancesReducer */],
        navigationUserInfo: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["f" /* navigationUserInfoReducer */],
        navigationUserRecentProjectsAndContests: __WEBPACK_IMPORTED_MODULE_4__navigation_navigation_reducer__["g" /* navigationUserRecentProjectsAndContestsReducer */],
        notificationsUserPreferences: __WEBPACK_IMPORTED_MODULE_8__notifications_notifications_reducer__["a" /* notificationsUserPreferencesReducer */],
        onlineOffline: __WEBPACK_IMPORTED_MODULE_6__online_offline_online_offline_reducer__["a" /* onlineOfflineReducer */],
        threads: __WEBPACK_IMPORTED_MODULE_7__thread_thread_reducer__["a" /* threadReducer */],
        threadUnreadCount: __WEBPACK_IMPORTED_MODULE_7__thread_thread_reducer__["b" /* threadUnreadCountReducer */],
    };
    var reducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ngrx_core_compose__["compose"])(__WEBPACK_IMPORTED_MODULE_2_ngrx_store_freeze__["storeFreeze"], __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["b" /* combineReducers */])(reducers);
    return reducer(state, action);
}
//# sourceMappingURL=store.js.map

/***/ }),

/***/ "cjBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_tracking_service__ = __webpack_require__("maH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracking_config__ = __webpack_require__("7eNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_interface__ = __webpack_require__("yQXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tracking_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemoryLeakTrackingComponent; });




var MemoryLeakTrackingComponent = (function () {
    function MemoryLeakTrackingComponent(errorTracking, config) {
        this.errorTracking = errorTracking;
        this.config = config;
        this.CHECK_INTERVAL = 10000; // 10 seconds
        this.MAX_MEMORY_LIMIT = 1000 * 1048576; // 1000MB
        this.MAX_PERCENT_THRESHOLD = 90;
        this.hadAlarmed = false;
    }
    MemoryLeakTrackingComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!(window.performance && window.performance.memory)) {
            return;
        }
        setTimeout(function () { return _this.checkMemoryUsage(); }, this.CHECK_INTERVAL);
    };
    MemoryLeakTrackingComponent.prototype.checkMemoryUsage = function () {
        var _this = this;
        requestAnimationFrame(function () {
            var hasAlarmed = false;
            var _a = window.performance.memory, jsHeapSizeLimit = _a.jsHeapSizeLimit, totalJSHeapSize = _a.totalJSHeapSize, usedJSHeapSize = _a.usedJSHeapSize;
            // Check if we've exceeded absolute memory limit
            if (usedJSHeapSize > _this.MAX_MEMORY_LIMIT) {
                hasAlarmed = true;
                var overage = usedJSHeapSize - _this.MAX_MEMORY_LIMIT;
                _this.errorTracking.captureMessage('Exceeded memory maximum limit', {
                    extra: { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize, overage: overage },
                });
            }
            // Check if we've exceeded relative memory limit for client
            if (usedJSHeapSize > _this.MAX_PERCENT_THRESHOLD / 100 * jsHeapSizeLimit) {
                hasAlarmed = true;
                _this.errorTracking.captureMessage('Memory usage exceeded', {
                    extra: {
                        jsHeapSizeLimit: jsHeapSizeLimit,
                        totalJSHeapSize: totalJSHeapSize,
                        usedJSHeapSize: usedJSHeapSize,
                        MAX_PERCENT_THRESHOLD: _this.MAX_PERCENT_THRESHOLD,
                    },
                });
            }
            // Only alert once
            if (!hasAlarmed) {
                setTimeout(function () { return _this.checkMemoryUsage(); }, _this.CHECK_INTERVAL);
            }
        });
    };
    MemoryLeakTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__error_tracking_service__["a" /* ErrorTracking */] }, { type: __WEBPACK_IMPORTED_MODULE_3__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_2__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return MemoryLeakTrackingComponent;
}());

//# sourceMappingURL=memory-leak-tracking.component.js.map

/***/ }),

/***/ "gW6X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_auth__ = __webpack_require__("5/rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datastore_config__ = __webpack_require__("6NNA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datastore_interface__ = __webpack_require__("LaRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datastore_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__datastore_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiHttp; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var ApiHttp = (function (_super) {
    __extends(ApiHttp, _super);
    function ApiHttp(backend, defaultOptions, auth, datastoreConfig) {
        var _this = _super.call(this, backend, defaultOptions) || this;
        _this.auth = auth;
        _this.datastoreConfig = datastoreConfig;
        return _this;
    }
    ApiHttp.prototype.fetch = function (config, pagination) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__["Observable"].of(config)
            .withLatestFrom(this.authHeader())
            .switchMap(function (_a) {
            var newConfig = _a[0], authHeader = _a[1];
            var baseUrl = newConfig.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            var search = pagination
                ? __assign({}, newConfig.params, { limit: pagination.limit, offset: pagination.offset }) : newConfig.params;
            return _super.prototype.get.call(_this, baseUrl + "/" + newConfig.endpoint, {
                headers: authHeader,
                search: _this.serialize(search),
            });
        })
            .map(function (res) { return res.json(); })
            .map(function (body) { return body.result; });
    };
    ApiHttp.prototype.post = function (config, payload) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__["Observable"].of(config)
            .withLatestFrom(this.authHeader(), function (c, h) { return [c, h]; })
            .switchMap(function (_a) {
            var newConfig = _a[0], authHeader = _a[1];
            var baseUrl = newConfig.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            return _super.prototype.post.call(_this, baseUrl + "/" + newConfig.endpoint, _this.serialize(__assign({}, payload, newConfig.params)), {
                headers: authHeader,
            });
        })
            .map(function (res) { return res.json(); })
            .map(function (body) { return body.result; });
    };
    ApiHttp.prototype.authHeader = function () {
        return this.auth.map(function (_a) {
            var uid = _a.uid, token = _a.token;
            return new __WEBPACK_IMPORTED_MODULE_1__angular_http__["l" /* Headers */]({ 'freelancer-auth-v2': uid + ";" + token });
        });
    };
    ApiHttp.prototype.serialize = function (obj) {
        var params = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["k" /* URLSearchParams */]();
        Object.entries(obj).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (typeof value === 'string') {
                params.set(key, value);
            }
            else if (typeof value === 'number') {
                params.set(key, String(value));
            }
            else if (Array.isArray(value)) {
                // This type casting shouldn't be necessary but is because of a TS bug.
                // https://github.com/Microsoft/TypeScript/issues/15315
                // https://github.com/Microsoft/TypeScript/issues/7294
                // Our backend expects arrays foo=[1,2] to be encoded as foo[]=1&foo[]=2
                value.forEach(function (v) {
                    params.append(key + "[]", String(v));
                });
            }
        });
        params.set('compact', 'true');
        return params;
    };
    ApiHttp.prototype.handleException = function (error) {
        // In a real world app, we might use a remote logging infrastructure
        var errMsg;
        if (error instanceof __WEBPACK_IMPORTED_MODULE_1__angular_http__["m" /* Response */]) {
            var body = error.json() || '';
            var err = body.error || JSON.stringify(body);
            errMsg = error.status + " - " + (error.statusText || '') + " " + err;
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__["Observable"].throw(errMsg);
    };
    ApiHttp.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_http__["c" /* XHRBackend */] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_http__["i" /* RequestOptions */] }, { type: __WEBPACK_IMPORTED_MODULE_2__shared_auth__["a" /* Auth */] }, { type: __WEBPACK_IMPORTED_MODULE_5__datastore_interface__["DatastoreConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_4__datastore_config__["a" /* DATASTORE_CONFIG */]] }] }]; };
    return ApiHttp;
}(__WEBPACK_IMPORTED_MODULE_1__angular_http__["j" /* Http */]));

//# sourceMappingURL=api-http.service.js.map

/***/ }),

/***/ "iQnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers_notifications__ = __webpack_require__("uJAx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers_notifications__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_projectFeed__ = __webpack_require__("5MCJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__reducers_projectFeed__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__reducers_projectFeed__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__reducers_projectFeed__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_userBalances__ = __webpack_require__("2qWf");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__reducers_userBalances__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers_userInfo__ = __webpack_require__("wQE3");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__reducers_userInfo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducers_userRecentProjectsAndContests__ = __webpack_require__("ZbSj");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__reducers_userRecentProjectsAndContests__["a"]; });






//# sourceMappingURL=navigation.reducer.js.map

/***/ }),

/***/ "jD7Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("bKWi");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return giveGetEligibilityReducer; });
/* unused harmony export transformGiveGetEligibility */

var giveGetEligibilityReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'giveGetEligibility') {
                var _a = action.payload, data = _a.data, ref = _a.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["d" /* mergeEntity */])(state, transformGiveGetEligibility(data), ref.path);
            }
            return state;
        default:
            return state;
    }
};
function transformGiveGetEligibility(eligible) {
    return eligible;
}
//# sourceMappingURL=give-get.reducer.js.map

/***/ }),

/***/ "jT3v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_user_timing_tracking_component__ = __webpack_require__("EVHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__ = __webpack_require__("sVtB");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_UserTimingTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_UserTimingTrackingComponent_0;
/* unused harmony export UserTimingTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */



var styles_UserTimingTrackingComponent = [];
var RenderType_UserTimingTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_UserTimingTrackingComponent,
    data: {}
});
function View_UserTimingTrackingComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [(l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_UserTimingTrackingComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 1, 'fl-user-timing-tracking', [], null, null, null, View_UserTimingTrackingComponent_0, RenderType_UserTimingTrackingComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_33" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_user_timing_tracking_component__["a" /* UserTimingTrackingComponent */], [__WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_tracking_service__["a" /* Tracking */]], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var UserTimingTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_34" /* ɵccf */]('fl-user-timing-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_user_timing_tracking_component__["a" /* UserTimingTrackingComponent */], View_UserTimingTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdXNlci10aW1pbmctdHJhY2tpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdXNlci10aW1pbmctdHJhY2tpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy91c2VyLXRpbWluZy10cmFja2luZy5jb21wb25lbnQudHMuVXNlclRpbWluZ1RyYWNraW5nQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3VzZXItdGltaW5nLXRyYWNraW5nLmNvbXBvbmVudC50cy5Vc2VyVGltaW5nVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC11c2VyLXRpbWluZy10cmFja2luZz48L2ZsLXVzZXItdGltaW5nLXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7eUJDQUE7Ozs7SUNBQTtnQkFBQTs7O0lBQUE7OzsifQ==
//# sourceMappingURL=user-timing-tracking.component.ngfactory.js.map

/***/ }),

/***/ "k/7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_service__ = __webpack_require__("sVtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking_config__ = __webpack_require__("7eNd");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoXSRFStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TrackingModule; });


var NoXSRFStrategy = (function () {
    function NoXSRFStrategy() {
    }
    NoXSRFStrategy.prototype.configureRequest = function (req) {
        // Remove `x-xsrf-token` from request headers since the tracking backend
        // doesn't care, and it avoids uneeded CORS preflight requests
    };
    return NoXSRFStrategy;
}());

var TrackingModule = (function () {
    function TrackingModule() {
    }
    TrackingModule.initialize = function (config) {
        return {
            ngModule: TrackingModule,
            providers: [__WEBPACK_IMPORTED_MODULE_0__tracking_service__["a" /* Tracking */], { provide: __WEBPACK_IMPORTED_MODULE_1__tracking_config__["a" /* TRACKING_CONFIG */], useValue: config }],
        };
    };
    return TrackingModule;
}());

//# sourceMappingURL=tracking.module.js.map

/***/ }),

/***/ "kZql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return environment; });
var environment = {
    production: true,
    gafBaseUrl: 'https://www.freelancer.com',
    authConfig: {
        baseUrl: 'https://www.freelancer.com/auth',
        authHashCookie: 'GETAFREE_AUTH_HASH_V2',
        userIdCookie: 'GETAFREE_USER_ID',
    },
    datastoreConfig: {
        apiBaseUrl: 'https://www.freelancer.com/api',
        ajaxBaseUrl: 'https://www.freelancer.com/ajax-api',
        webSocketUrl: 'https://notifications.freelancer.com',
    },
    trackingConfig: {
        trackingEndpoint: 'https://t.freelancer.com/0px.gif',
        sessionCookie: '_tracking_session',
        navigationPerformanceSamplingRate: 1,
        enableErrorTracking: true,
        sentryDsn: 'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
        gitRevision: '4d638d6bc75',
        buildDate: 'Fri Jun 23 2017 04:22:48 GMT-0400 (EDT)',
    },
    billingConfig: {
        baseUrl: 'https://api.flnbln.net',
    },
    facebookAppId: '',
    languageCookie: 'GETAFREE_LANGUAGE',
};
//# sourceMappingURL=environment.js.map

/***/ }),

/***/ "maH+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_auth__ = __webpack_require__("5/rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_config__ = __webpack_require__("7eNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_interface__ = __webpack_require__("yQXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__tracking_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorTracking; });





var ErrorTracking = (function () {
    function ErrorTracking(auth, config) {
        this.auth = auth;
        this.config = config;
        if (this.config.enableErrorTracking) {
            __WEBPACK_IMPORTED_MODULE_0_raven_js__["config"](this.config.sentryDsn, {
                release: this.config.gitRevision,
                tags: {
                    releaseDate: this.config.buildDate,
                },
            });
        }
    }
    ErrorTracking.prototype.captureMessage = function (msg, options) {
        var _this = this;
        if (this.config.enableErrorTracking) {
            this.auth
                .map(function (_a) {
                var uid = _a.uid;
                _this.setUserId(uid);
                __WEBPACK_IMPORTED_MODULE_0_raven_js__["captureMessage"](msg, options);
            })
                .toPromise();
        }
        else {
            console.error(msg, options);
        }
    };
    ErrorTracking.prototype.captureException = function (error) {
        var _this = this;
        if (this.config.enableErrorTracking) {
            this.auth
                .map(function (_a) {
                var uid = _a.uid;
                _this.setUserId(uid);
                __WEBPACK_IMPORTED_MODULE_0_raven_js__["captureException"](error);
            })
                .toPromise();
        }
        else {
            console.error(error);
        }
    };
    ErrorTracking.prototype.setUserId = function (id) {
        if (id) {
            __WEBPACK_IMPORTED_MODULE_0_raven_js__["setUserContext"]({ id: String(id) });
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0_raven_js__["setUserContext"]();
        }
    };
    ErrorTracking.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__shared_auth__["a" /* Auth */] }, { type: __WEBPACK_IMPORTED_MODULE_4__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_3__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return ErrorTracking;
}());

//# sourceMappingURL=error-tracking.service.js.map

/***/ }),

/***/ "sVtB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_auth__ = __webpack_require__("5/rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_cookie__ = __webpack_require__("VffS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_config__ = __webpack_require__("7eNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracking_interface__ = __webpack_require__("yQXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__tracking_interface__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tracking; });
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};






var Tracking = (function () {
    function Tracking(http, auth, cookies, config) {
        this.http = http;
        this.auth = auth;
        this.cookies = cookies;
        this.config = config;
        this.MAX_GET_LENGTH = 2000;
        var sessionId = this.cookies.get(this.config.sessionCookie);
        if (!sessionId) {
            // Generate a new one if not.
            sessionId = this.generateSessionId();
            this.cookies.put('_tracking_session', sessionId, {
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            });
        }
        this.sessionId = sessionId;
    }
    Tracking.prototype.track = function (eventName, eventData) {
        var _this = this;
        var timestamp = Date.now().toString();
        return new Promise(function (resolve) {
            window.requestIdleCallback(function () {
                _this.auth
                    .switchMap(function (_a) {
                    var uid = _a.uid;
                    var e = __assign({
                        acct: window.location.hostname.replace(/^www/, ''),
                        t: timestamp,
                        en: eventName,
                        location: window.location.href,
                        user_id: uid ? uid : undefined,
                        session_id: _this.sessionId,
                    }, eventData);
                    // compute rough payload size
                    var size = Object.values(e).reduce(function (acc, value) {
                        acc += value ? String(value).length : 0;
                        return acc;
                    }, 0);
                    if (size > _this.MAX_GET_LENGTH) {
                        return _this.http.post(_this.config.trackingEndpoint, e);
                    }
                    else {
                        return _this.http.get(_this.config.trackingEndpoint, {
                            search: _this.serialize(e),
                        });
                    }
                })
                    .mapTo(undefined)
                    .toPromise()
                    .then(resolve);
            });
        });
    };
    Tracking.prototype.push = function (e) {
        this.track(e[0], e[1]);
    };
    Tracking.prototype.generateSessionId = function () {
        var s4 = function () {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        };
        return "" + s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
    };
    Tracking.prototype.serialize = function (obj) {
        var params = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["k" /* URLSearchParams */]();
        Object.keys(obj).forEach(function (key) {
            params.set(key, obj[key]);
        });
        return params;
    };
    Tracking.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_http__["j" /* Http */] }, { type: __WEBPACK_IMPORTED_MODULE_2__shared_auth__["a" /* Auth */] }, { type: __WEBPACK_IMPORTED_MODULE_3__shared_cookie__["a" /* CookieService */] }, { type: __WEBPACK_IMPORTED_MODULE_5__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_4__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return Tracking;
}());

//# sourceMappingURL=tracking.service.js.map

/***/ }),

/***/ "t/ph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_rxjs_operators__ = __webpack_require__("F5VT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("zPvt");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompatComponent; });
// This allows us to load Angular components on legacy server-side pages.



var CompatComponent = (function () {
    function CompatComponent(injector, loader) {
        this.injector = injector;
        this.loader = loader;
    }
    CompatComponent.prototype.ngOnInit = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_2__components__["a" /* components */].forEach(function (_a) {
            var selector = _a.selector, loadChildren = _a.loadChildren, component = _a.component;
            // Only bootstrap the components on the page
            if (document.getElementsByTagName(selector)[0]) {
                _this.loader
                    .load(loadChildren)
                    .then(function (ngModuleFactory) {
                    // NgModuleFactory
                    var componentFactory = ngModuleFactory
                        .create(_this.injector) // ngModuleRef
                        .componentFactoryResolver.resolveComponentFactory(component);
                    _this.entryPoint.createComponent(componentFactory);
                });
            }
        });
    };
    CompatComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["X" /* Injector */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Z" /* SkipSelf */] }] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["z" /* NgModuleFactoryLoader */] }]; };
    return CompatComponent;
}());

//# sourceMappingURL=compat.component.js.map

/***/ }),

/***/ "tTqL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiSet; });
/* An implementation of a multiset.
 * Heavily modified from the npm package cell-multiset.
*/
var MultiSet = (function () {
    function MultiSet(elms) {
        var _this = this;
        this.elements = new Map();
        if (elms) {
            elms.forEach(function (elm) { return _this.add(elm); });
        }
        return this;
    }
    MultiSet.prototype.add = function () {
        var elms = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elms[_i] = arguments[_i];
        }
        return this.addCollection(elms);
    };
    MultiSet.prototype.addCollection = function (elms) {
        var _this = this;
        elms.forEach(function (elm) {
            _this.elements.set(elm, (_this.elements.get(elm) || 0) + 1);
        });
        return this;
    };
    Object.defineProperty(MultiSet.prototype, "cardinality", {
        get: function () {
            var len = 0;
            this.elements.forEach(function (multiplicity) { return (len += multiplicity); });
            return len;
        },
        enumerable: true,
        configurable: true
    });
    MultiSet.prototype.clear = function () {
        this.elements.clear();
        return this;
    };
    MultiSet.prototype.contains = function (multiset) {
        var _this = this;
        var found = true;
        multiset.elements.forEach(function (multiplicity, elm) {
            if (multiplicity > _this.multiplicity(elm)) {
                found = false;
                return;
            }
        });
        return found;
    };
    MultiSet.prototype.difference = function (multiset) {
        var _this = this;
        this.elements.forEach(function (multiplicity, elm) {
            var nmul = multiplicity - multiset.multiplicity(elm);
            if (nmul <= 0) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, nmul);
            }
        });
        return this;
    };
    MultiSet.prototype.Difference = function (multiset) {
        var output = new MultiSet();
        this.elements.forEach(function (multiplicity, elm) {
            var nmul = multiplicity - multiset.multiplicity(elm);
            if (nmul > 0) {
                output.elements.set(elm, nmul);
            }
        });
        return output;
    };
    MultiSet.prototype.each = function (callback, ctx) {
        var _this = this;
        var all = true;
        this.elements.forEach(function (mul, elm) {
            if (callback.call(ctx, elm, mul, _this) === false) {
                all = false;
                return;
            }
        });
        return all;
    };
    MultiSet.prototype.entries = function () {
        return this.elements.entries();
    };
    MultiSet.prototype.equals = function (multiset) {
        var _this = this;
        return multiset.each(function (mul, elm) {
            return mul !== _this.multiplicity(elm);
        });
    };
    MultiSet.prototype.has = function (elm) {
        return !!this.elements.get(elm);
    };
    MultiSet.prototype.isEmpty = function () {
        return !!this.elements.size;
    };
    MultiSet.prototype.intersection = function (multiset) {
        var _this = this;
        var nmul;
        this.elements.forEach(function (multiplicity, elm) {
            nmul = Math.min(multiplicity, multiset.multiplicity(elm));
            if (!nmul) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, nmul);
            }
        });
        return this;
    };
    MultiSet.prototype.Intersection = function (multiset) {
        var output = new MultiSet();
        var nmul;
        this.elements.forEach(function (multiplicity, elm) {
            nmul = Math.min(multiplicity, multiset.multiplicity(elm));
            if (nmul) {
                output.elements.set(elm, nmul);
            }
        });
        return output;
    };
    MultiSet.prototype.isSubsetOf = function (multiset) {
        return multiset.contains(this);
    };
    MultiSet.prototype.keys = function () {
        return this.elements.keys();
    };
    MultiSet.prototype.multiplicity = function (elm) {
        return this.elements.get(elm) || 0;
    };
    MultiSet.prototype.remove = function () {
        var elms = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elms[_i] = arguments[_i];
        }
        return this.removeCollection(elms);
    };
    MultiSet.prototype.removeCollection = function (elms) {
        var _this = this;
        elms.forEach(function (elm) {
            var multiplicity = _this.elements.get(elm) || 0;
            if (multiplicity === 1) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, Math.max(0, multiplicity - 1));
            }
        });
        return this;
    };
    MultiSet.prototype.symmetricDifference = function (multiset) {
        var _this = this;
        multiset.elements.forEach(function (multiplicity, elm) {
            var diff = _this.multiplicity(elm) - multiplicity;
            if (!diff) {
                _this.elements.delete(elm);
            }
            else {
                _this.elements.set(elm, Math.abs(diff));
            }
        });
        return this;
    };
    MultiSet.prototype.union = function (multiset) {
        var _this = this;
        multiset.elements.forEach(function (multiplicity, elm) {
            return _this.elements.set(elm, Math.max(multiplicity, _this.multiplicity(elm)));
        });
        return this;
    };
    MultiSet.prototype.values = function () {
        return Array.from(this.elements.keys());
    };
    return MultiSet;
}());

//# sourceMappingURL=multiset.js.map

/***/ }),

/***/ "uJAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("bKWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transformers__ = __webpack_require__("7Aw9");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationNotificationsReducer; });


var navigationNotificationsReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationNotifications') {
                var data = action.payload.data;
                var ref = action.payload.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transformers__["e" /* transformNavigationNotifications */])(data.hits.hits.map(function (hit) { return hit._source; })), ref);
            }
            return state;
        case 'WS_MESSAGE':
            var userId = action.payload.userId;
            switch (action.payload.type) {
                case 'award':
                case 'bid':
                case 'contestAwardedToEmployer':
                case 'contestEntry':
                case 'contestPCBNotification':
                case 'draftContest':
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["c" /* mergeEntities */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transformers__["e" /* transformNavigationNotifications */])([action.payload]), {
                        path: ['navigationNotifications', userId],
                    });
                // I'm not sure if the newsfeed has these types. If they are possible then they should be added to NewsfeedApiResponseEntry.
                case 'awardBadge':
                case 'awardCredit':
                case 'awardMilestoneReminder':
                case 'awardReminder':
                case 'awardXp':
                case 'completed':
                case 'contactRequestReceived':
                case 'contest':
                case 'contestAwardedToFreelancer':
                case 'contestEntryBoughtToEmployer':
                case 'contestEntryBoughtToFreelancer':
                case 'contestPCBNotificationFullView':
                case 'createMilestone':
                case 'denyed':
                case 'failingProject':
                case 'highLtvAnnualDiscount':
                case 'inviteToContest':
                case 'inviteUserBid':
                case 'invoiceRequested':
                case 'levelup':
                case 'notifyfollower':
                case 'project':
                case 'projectRecruiter':
                case 'quickHireProject':
                case 'releaseMilestone':
                case 'requestEndProject':
                case 'requestMilestone':
                case 'requestToRelease':
                case 'serviceApproved':
                case 'serviceProjectEndingSeller':
                case 'serviceProjectPostedSeller':
                case 'serviceRejected':
                case 'signUpFreeTrialUpsell':
                case 'sitesBinCreated':
                case 'sitesHandOverMessageSent':
                case 'sitesListingStatusChanged':
                case 'sitesMessageSent':
                case 'sitesOfferCreated':
                case 'upsellCrowdsourceFinding':
                case 'xpContest':
                    return state;
                default:
                    return state;
            }
        default:
            return state;
    }
};
//# sourceMappingURL=notifications.js.map

/***/ }),

/***/ "wIBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__ = __webpack_require__("MQMf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("bKWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backend__ = __webpack_require__("OoH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_http_service__ = __webpack_require__("gW6X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__websocket__ = __webpack_require__("8kLz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__list_observable__ = __webpack_require__("6mmy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__object_observable__ = __webpack_require__("VaD5");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Datastore; });








var Datastore = (function () {
    function Datastore(store, apiHttp, webSocketService) {
        this.store = store;
        this.apiHttp = apiHttp;
        this.webSocketService = webSocketService;
    }
    Datastore.prototype.list = function (arg1) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var optionsQuery = {};
        if (args.length && args[args.length - 1].query) {
            optionsQuery = args.pop().query;
        }
        var args$ = [arg1].concat(args).map(function (key) { return (key instanceof __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"] ? key : __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(key)); });
        var pathStream = __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].combineLatest(args$);
        var queryStream = __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].combineLatest([
            optionsQuery.limit instanceof __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"]
                ? optionsQuery.limit
                : __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(optionsQuery.limit),
            optionsQuery.offset instanceof __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"]
                ? optionsQuery.offset
                : __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(optionsQuery.offset),
        ], function (limit, offset) { return ({ limit: limit, offset: offset }); });
        var refStream = __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].combineLatest([pathStream, queryStream], function (path, query) { return ({ path: path, query: query }); })
            .multicast(function () { return new __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__["ReplaySubject"](1); })
            .refCount();
        var fetchStream = refStream.switchMap(function (ref) {
            var path = ref.path, query = ref.query;
            var fetch = __WEBPACK_IMPORTED_MODULE_3__backend__["a" /* backend */][path[0]].fetch;
            if (fetch) {
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(fetch(path[1], query))
                    .switchMap(function (config) { return _this.apiHttp.fetch(config, query); })
                    .do(function (data) {
                    _this.store.dispatch({
                        type: 'API_FETCH_SUCCESS',
                        payload: { data: data, ref: ref },
                    });
                })
                    .mapTo({ path: path, query: query });
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
            }
        });
        var websocketStream = this.webSocketService.fromServerStream.combineLatest(refStream, function (ws, ref) { return ref; });
        return new __WEBPACK_IMPORTED_MODULE_6__list_observable__["a" /* ListObservable */](refStream, this.apiHttp, this.store, __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].merge(refStream, fetchStream, websocketStream)
            .switchMap(function (_a) {
            var path = _a.path;
            return (_b = _this.store).pluck.apply(_b, path);
            var _b;
        })
            .distinctUntilChanged()
            .map(function (data) {
            if (data && data.lists) {
                return data.lists['default']
                    .slice(optionsQuery.offset || 0)
                    .map(function (id) { return data.entities[id]; });
            }
            else {
                return [];
            }
        }));
    };
    Datastore.prototype.object = function (arg1) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var args$ = [arg1].concat(args).map(function (key) { return (key instanceof __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"] ? key : __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(key)); });
        var refStream = __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].combineLatest(args$)
            .map(function (path) { return ({ path: path }); })
            .multicast(function () { return new __WEBPACK_IMPORTED_MODULE_1_rxjs_ReplaySubject__["ReplaySubject"](1); })
            .refCount();
        var fetchStream = refStream.switchMap(function (_a) {
            var path = _a.path;
            if (__WEBPACK_IMPORTED_MODULE_3__backend__["a" /* backend */][path[0]].fetch) {
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__backend__["a" /* backend */][path[0]].fetch(path[1]))
                    .switchMap(function (config) { return _this.apiHttp.fetch(config); })
                    .do(function (data) {
                    _this.store.dispatch({
                        type: 'API_FETCH_SUCCESS',
                        payload: { data: data, ref: { path: path } },
                    });
                })
                    .mapTo({ path: path });
            }
            else {
                return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
            }
        });
        var subscriptionStream = arg1 ===
            'onlineOffline'
            ? this.webSocketService
                .subscribeOnlineOffline(args$[1])
                .combineLatest(refStream, function (ss, ref) { return ref; })
            : refStream;
        var websocketStream = this.webSocketService.fromServerStream.combineLatest(refStream, function (ws, ref) { return ref; });
        return new __WEBPACK_IMPORTED_MODULE_7__object_observable__["a" /* ObjectObservable */](refStream, this.apiHttp, this.store, __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].merge(refStream, fetchStream, subscriptionStream, websocketStream)
            .switchMap(function (_a) {
            var path = _a.path;
            return (_b = _this.store).pluck.apply(_b, path);
            var _b;
        })
            .distinctUntilChanged()
            .filter(function (obj) { return obj !== undefined; }));
    };
    Datastore.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_2__store__["b" /* Store */] }, { type: __WEBPACK_IMPORTED_MODULE_4__api_http_service__["a" /* ApiHttp */] }, { type: __WEBPACK_IMPORTED_MODULE_5__websocket__["a" /* WebSocketService */] }]; };
    return Datastore;
}());

//# sourceMappingURL=datastore.js.map

/***/ }),

/***/ "wQE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("bKWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transformers__ = __webpack_require__("7Aw9");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationUserInfoReducer; });


var navigationUserInfoReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'API_FETCH_SUCCESS':
            if (action.payload &&
                action.payload.ref.path[0] === 'navigationUserInfo') {
                var _a = action.payload, data = _a.data, ref = _a.ref;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store__["d" /* mergeEntity */])(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transformers__["b" /* transformNavigationUserInfo */])(data), ref.path);
            }
            return state;
        default:
            return state;
    }
};
//# sourceMappingURL=userInfo.js.map

/***/ }),

/***/ "wdny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracking_module__ = __webpack_require__("k/7A");
/* unused harmony reexport TrackingModule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking_component__ = __webpack_require__("PzJT");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__tracking_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__custom_error_handler_service__ = __webpack_require__("UbRn");
/* unused harmony reexport CustomErrorHandler */



//# sourceMappingURL=index.js.map

/***/ }),

/***/ "wkYe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_boomerang_boomerang_js__ = __webpack_require__("KjzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_boomerang_boomerang_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_boomerang_boomerang_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_boomerang_plugins_auto_xhr_js__ = __webpack_require__("VPKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_boomerang_plugins_auto_xhr_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_boomerang_plugins_auto_xhr_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_boomerang_plugins_spa_js__ = __webpack_require__("/aXI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_boomerang_plugins_spa_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_boomerang_plugins_spa_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_boomerang_plugins_history_js__ = __webpack_require__("AAEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_boomerang_plugins_history_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_boomerang_plugins_history_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_boomerang_plugins_rt_js__ = __webpack_require__("gcTG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_boomerang_plugins_rt_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_boomerang_plugins_rt_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_boomerang_plugins_navtiming_js__ = __webpack_require__("aAem");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_boomerang_plugins_navtiming_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_boomerang_plugins_navtiming_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_boomerang_plugins_restiming_js__ = __webpack_require__("gUQd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_boomerang_plugins_restiming_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_boomerang_plugins_restiming_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tracking_service__ = __webpack_require__("sVtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tracking_config__ = __webpack_require__("7eNd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracking_interface__ = __webpack_require__("yQXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracking_interface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__tracking_interface__);
/* unused harmony export NavigationPerformanceCategory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationPerformanceTrackingComponent; });











var NavigationPerformanceCategory;
(function (NavigationPerformanceCategory) {
    NavigationPerformanceCategory[NavigationPerformanceCategory["INITIAL_PAGE_LOAD"] = 0] = "INITIAL_PAGE_LOAD";
    NavigationPerformanceCategory[NavigationPerformanceCategory["ROUTE_CHANGE"] = 1] = "ROUTE_CHANGE";
})(NavigationPerformanceCategory || (NavigationPerformanceCategory = {}));
var NavigationPerformanceTrackingComponent = (function () {
    function NavigationPerformanceTrackingComponent(t, config) {
        this.t = t;
        this.config = config;
    }
    NavigationPerformanceTrackingComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (Math.random() > this.config.navigationPerformanceSamplingRate) {
            return;
        }
        // Whenever Boomerang intercepts an XHR request, it will check if that
        // request matches anything in the exclude list, and if it does, Boomerang
        // will not instrument, time, or beacon that request
        BOOMR.xhr_excludes = {
            't.freelancer.com': true,
            'googleads.g.doubleclick.net': true,
            'static.doubleclick.net': true,
            'www.googletagmanager.com': true,
            'www.google.com': true,
            'connect.facebook.net': true,
        };
        BOOMR.init({
            log: function (message, level, source) {
                if (level === 'error') {
                    console.error(message, source);
                }
            },
            autorun: false,
            History: {
                auto: true,
                enabled: true,
            },
        });
        // boomerang as its own error handling thing
        BOOMR.plugins.Errors = {
            is_supported: function () {
                return true;
            },
            is_complete: function () {
                return true;
            },
            send: function (err) {
                throw err;
            },
        };
        var previousUrl;
        BOOMR.subscribe('before_beacon', function (e) {
            if (e['http.initiator'] !== 'spa_hard' && e['http.initiator'] !== 'spa') {
                return;
            }
            // Previous URL
            if (!previousUrl) {
                previousUrl = e.r;
            }
            var data = {
                category: e['http.initiator'] !== 'spa'
                    ? NavigationPerformanceCategory.INITIAL_PAGE_LOAD
                    : NavigationPerformanceCategory.ROUTE_CHANGE,
                totalTime: e.t_done,
                backendTime: e.t_resp,
                frontendTime: e.t_page,
                previousUrl: previousUrl,
                resourceTimings: e.restiming,
            };
            // NavigationTimings
            if (e.nt_nav_st) {
                Object.assign(data, {
                    // PerformanceNavigation
                    redirectCount: e.nt_red_cnt,
                    navigationType: e.nt_nav_type,
                    // PerformanceTiming
                    navigationStart: e.nt_nav_st,
                    redirectStart: e.nt_red_st,
                    redirectEnd: e.nt_red_end,
                    fetchStart: e.nt_fet_st,
                    domainLookupStart: e.nt_dns_st,
                    domainLookupEnd: e.nt_dns_end,
                    connectStart: e.nt_con_st,
                    connectEnd: e.nt_con_end,
                    requestStart: e.nt_req_st,
                    responseStart: e.nt_res_st,
                    responseEnd: e.nt_res_end,
                    domLoading: e.nt_domloading,
                    domInteractive: e.nt_domint,
                    domContentLoadedEventStart: e.nt_domcontloaded_st,
                    domContentLoadedEventEnd: e.nt_domcontloaded_end,
                    domComplete: e.nt_domcomp,
                    loadEventStart: e.nt_load_st,
                    loadEventEnd: e.nt_load_end,
                    unloadEventStart: e.nt_unload_st,
                    unloadEventEnd: e.nt_unload_end,
                });
                if (e.nt_first_paint) {
                    // First paint
                    Object.assign(data, {
                        firstPaint: e.nt_first_paint * 1000,
                    });
                }
            }
            // Fire the event
            _this.t.track('page_performance_timings', data);
            // Clear the Resource Timings Buffer
            if (window.performance && window.performance.clearResourceTimings) {
                window.performance.clearResourceTimings();
            }
            previousUrl = window.location.href;
            // Notify boomerang that we've fired the beacon
            BOOMR.fireEvent('onbeacon', data);
        });
    };
    NavigationPerformanceTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_8__tracking_service__["a" /* Tracking */] }, { type: __WEBPACK_IMPORTED_MODULE_10__tracking_interface__["TrackingConfig"], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_0" /* Inject */], args: [__WEBPACK_IMPORTED_MODULE_9__tracking_config__["a" /* TRACKING_CONFIG */]] }] }]; };
    return NavigationPerformanceTrackingComponent;
}());

//# sourceMappingURL=navigation-performance-tracking.component.js.map

/***/ }),

/***/ "xfqM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_memory_leak_tracking_component__ = __webpack_require__("cjBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_error_tracking_service__ = __webpack_require__("maH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__ = __webpack_require__("7eNd");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderType_MemoryLeakTrackingComponent; });
/* harmony export (immutable) */ __webpack_exports__["a"] = View_MemoryLeakTrackingComponent_0;
/* unused harmony export MemoryLeakTrackingComponentNgFactory */
/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */




var styles_MemoryLeakTrackingComponent = [];
var RenderType_MemoryLeakTrackingComponent = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_29" /* ɵcrt */]({
    encapsulation: 2,
    styles: styles_MemoryLeakTrackingComponent,
    data: {}
});
function View_MemoryLeakTrackingComponent_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [(l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 0, null, null, null, null, null, null, null))], null, null);
}
function View_MemoryLeakTrackingComponent_Host_0(l) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["_30" /* ɵvid */](0, [
        (l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["_32" /* ɵeld */](0, null, null, 1, 'fl-memory-leak-tracking', [], null, null, null, View_MemoryLeakTrackingComponent_0, RenderType_MemoryLeakTrackingComponent)),
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["_33" /* ɵdid */](114688, null, 0, __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_memory_leak_tracking_component__["a" /* MemoryLeakTrackingComponent */], [
            __WEBPACK_IMPORTED_MODULE_2__app_shared_tracking_error_tracking_service__["a" /* ErrorTracking */],
            __WEBPACK_IMPORTED_MODULE_3__app_shared_tracking_tracking_config__["a" /* TRACKING_CONFIG */]
        ], null, null)
    ], function (ck, v) {
        ck(v, 1, 0);
    }, null);
}
var MemoryLeakTrackingComponentNgFactory = __WEBPACK_IMPORTED_MODULE_0__angular_core__["_34" /* ɵccf */]('fl-memory-leak-tracking', __WEBPACK_IMPORTED_MODULE_1__app_shared_tracking_memory_leak_tracking_component__["a" /* MemoryLeakTrackingComponent */], View_MemoryLeakTrackingComponent_Host_0, {}, {}, []);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbWVtb3J5LWxlYWstdHJhY2tpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvbWVtb3J5LWxlYWstdHJhY2tpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy9tZW1vcnktbGVhay10cmFja2luZy5jb21wb25lbnQudHMuTWVtb3J5TGVha1RyYWNraW5nQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9tbnQvamVua2lucy1zbGF2ZS13b3Jrc3BhY2Uvd29ya3NwYWNlL2dhZi1idWlsZC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL21lbW9yeS1sZWFrLXRyYWNraW5nLmNvbXBvbmVudC50cy5NZW1vcnlMZWFrVHJhY2tpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmctY29udGFpbmVyPjwvbmctY29udGFpbmVyPiIsIjxmbC1tZW1vcnktbGVhay10cmFja2luZz48L2ZsLW1lbW9yeS1sZWFrLXRyYWNraW5nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3lCQ0FBOzs7O0lDQUE7Z0JBQUE7OztJQUFBO0tBQUE7OztJQUFBOzs7In0=
//# sourceMappingURL=memory-leak-tracking.component.ngfactory.js.map

/***/ }),

/***/ "yQXN":
/***/ (function(module, exports) {

//# sourceMappingURL=tracking.interface.js.map

/***/ }),

/***/ "yUzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_cookie__ = __webpack_require__("VffS");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyntheticPerformanceTrackingComponent; });


var SyntheticPerformanceTrackingComponent = (function () {
    function SyntheticPerformanceTrackingComponent(cookies, renderer) {
        this.cookies = cookies;
        this.renderer = renderer;
    }
    SyntheticPerformanceTrackingComponent.prototype.ngOnInit = function () {
        /**
         * Adds a 'sc-no-animation' class on the root element ('html') when a
         * 'no_animation' cookie is present. This can then be used to disable CSS
         * animations / transitions as they don't play nice with synthetics monitoring
         * & visual completness score (a.k.a. Speed Index).
         */
        if (this.cookies.get('no_animation')) {
            this.renderer.addClass(document.documentElement, 'sc-no-animation');
        }
    };
    SyntheticPerformanceTrackingComponent.ctorParameters = function () { return [{ type: __WEBPACK_IMPORTED_MODULE_1__shared_cookie__["a" /* CookieService */] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["_21" /* Renderer2 */] }]; };
    return SyntheticPerformanceTrackingComponent;
}());

//# sourceMappingURL=synthetic-performance-tracking.component.js.map

/***/ }),

/***/ "zPvt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_tracking__ = __webpack_require__("wdny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compat_navigation_component__ = __webpack_require__("0D9j");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return components; });
// Add here the components that you want to bootstrap on PHP pages

// import { NavigationComponent } from '../app/navigation/navigation.component';

var components = [
    {
        selector: 'webapp-compat-tracking',
        loadChildren: 'app/@shared/tracking/tracking.module#TrackingModule',
        component: __WEBPACK_IMPORTED_MODULE_0__shared_tracking__["a" /* TrackingComponent */],
        path: 'hack_path_not_used',
    },
    {
        selector: 'webapp-compat-navigation',
        loadChildren: 'compat/compat-navigation.module#CompatNavigationModule',
        component: __WEBPACK_IMPORTED_MODULE_1__compat_navigation_component__["a" /* CompatNavigationComponent */],
        path: 'hack_path_not_used',
    },
];
//# sourceMappingURL=components.js.map

/***/ })

},[1]);


// WEBPACK FOOTER //
// main.4b84df45759e1a3b46bf.bundle.js